
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fkiVa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $51f3ae09ed1fe9d7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "HistoryItemComponent", () => (parcelRequire("9DsBy")).default);
$parcel$export(module.exports, "HistoryItem", () => (parcelRequire("eCkNV")).default);
$parcel$export(module.exports, "useIssueHistoryUi", () => (parcelRequire("hO6CD")).useIssueHistoryUi);
$parcel$export(module.exports, "Change", () => (parcelRequire("iM8sv")).default);
$parcel$export(module.exports, "GroupedChange", () => (parcelRequire("yo0Ud")).default);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");

var $jGtPF = parcelRequire("jGtPF");

var $e9OSL = parcelRequire("e9OSL");

var $Do7wq = parcelRequire("Do7wq");

var $7iDSo = parcelRequire("7iDSo");

var $20JeF = parcelRequire("20JeF");

var $l5e25 = parcelRequire("l5e25");

var $9DsBy = parcelRequire("9DsBy");

var $eCkNV = parcelRequire("eCkNV");

var $hO6CD = parcelRequire("hO6CD");

var $iM8sv = parcelRequire("iM8sv");

var $yo0Ud = parcelRequire("yo0Ud");
const $51f3ae09ed1fe9d7$var$IssueHistoryContainer = ({ issueKey: issueKey, timeZone: timeZone, sortOrder: sortOrder, GroupedActivityEntryComponent: GroupedActivityEntryComponent, issueViewRelayFragment: issueViewRelayFragment })=>{
    const shouldUseRelayIssueHistory = (0, $bmoS1.useShouldUseRelayIssueHistory)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const sendHistoryFetchAnalytics = (0, $eJOHy.useCallback)((error)=>{
        const aggError = error ? (0, $e9OSL.extractFirstErrorFromRelayError)(error) : null;
        const errorMessage = error ? aggError?.message || error?.message : undefined;
        (0, $jGtPF.sendExperienceAnalytics)({
            error: aggError || error,
            getExperienceDescription: ({ wasSuccessful: wasSuccessful, statusCode: statusCode })=>(0, $l5e25.experienceDescription)({
                    experience: 'issueHistory',
                    action: 'FETCH_PAGE',
                    analyticsSource: 'issueHistoryFetch',
                    wasSuccessful: wasSuccessful,
                    projectType: projectType,
                    frameworkType: 'relay',
                    ...errorMessage !== undefined ? {
                        errorMessage: errorMessage
                    } : null,
                    ...statusCode !== undefined && {
                        statusCode: statusCode
                    }
                })
        });
    }, [
        projectType
    ]);
    if (shouldUseRelayIssueHistory) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "issue-history-relay",
        packageName: "jiraIssueHistory",
        teamName: "bento",
        onError: (location, error)=>{
            sendHistoryFetchAnalytics(error);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Do7wq.TimezoneProvider), {
        value: timeZone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $20JeF.default), {
        issueKey: issueKey,
        sortOrder: sortOrder,
        GroupedActivityEntryComponent: GroupedActivityEntryComponent,
        onHistoryFetchAnalytics: sendHistoryFetchAnalytics
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "issue-history"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Do7wq.TimezoneProvider), {
        value: timeZone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iDSo.default), {
        issueKey: issueKey,
        sortOrder: sortOrder,
        GroupedActivityEntryComponent: GroupedActivityEntryComponent,
        issueViewRelayFragment: issueViewRelayFragment
    })));
};
var $51f3ae09ed1fe9d7$export$2e2bcd8739ae039 = $51f3ae09ed1fe9d7$var$IssueHistoryContainer;

});
parcelRegister("jGtPF", function(module, exports) {
$parcel$export(module.exports, "sendExperienceAnalytics", () => $9c07754293fa47a8$export$4a95ada1b8228562);



var $dMM78 = parcelRequire("dMM78");

var $4cTDP = parcelRequire("4cTDP");

var $3ibpe = parcelRequire("3ibpe");
const $9c07754293fa47a8$var$successfulErrorStatusCodes = [
    (0, $3a153a61cf6b691b$export$9de493bcd9b1d977),
    (0, $3a153a61cf6b691b$export$67d19e9a991baa07),
    (0, $3a153a61cf6b691b$export$8bca792d963eb0ef)
];
const $9c07754293fa47a8$var$abortableStatusCodes = [
    (0, $3a153a61cf6b691b$export$6763168a631449a2)
];
const $9c07754293fa47a8$var$classificationPayload = {
    ANALYTICS_SUCCESS: {
        wasSuccessful: true,
        action: (0, $f17fa9e5c82da056$export$627ef4c1ed2d7a9a)
    },
    ANALYTICS_ABORT: {
        wasSuccessful: true,
        action: (0, $f17fa9e5c82da056$export$aeeb00d0845d24d8)
    },
    ANALYTICS_FAIL: {
        wasSuccessful: false,
        action: (0, $f17fa9e5c82da056$export$b48b3d1872522384)
    }
};
const $9c07754293fa47a8$var$isErrorOmitted = (error)=>error === null;
const $9c07754293fa47a8$var$isStatusCodeConsideredSuccessful = (error)=>// @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    $9c07754293fa47a8$var$successfulErrorStatusCodes.includes(error?.statusCode);
const $9c07754293fa47a8$var$isStatusCodeAbortable = (error)=>// @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    $9c07754293fa47a8$var$abortableStatusCodes.includes(error?.statusCode);
const $9c07754293fa47a8$var$reduceClassificationOld = (error)=>{
    if ($9c07754293fa47a8$var$isErrorOmitted(error) || $9c07754293fa47a8$var$isStatusCodeConsideredSuccessful(error)) return 'ANALYTICS_SUCCESS';
    if ($9c07754293fa47a8$var$isStatusCodeAbortable(error)) return 'ANALYTICS_ABORT';
    return 'ANALYTICS_FAIL';
};
const $9c07754293fa47a8$var$reduceClassificationNew = (error)=>{
    if ($9c07754293fa47a8$var$isErrorOmitted(error)) return 'ANALYTICS_SUCCESS';
    return 'ANALYTICS_FAIL';
};
const $9c07754293fa47a8$var$getReduceClassification = ()=>(0, $4cTDP.fg)('bento_send_4xx_to_task_fail_gate_1') ? $9c07754293fa47a8$var$reduceClassificationNew : $9c07754293fa47a8$var$reduceClassificationOld;
const $9c07754293fa47a8$export$4a95ada1b8228562 = ({ getExperienceDescription: getExperienceDescription, error: error = null })=>{
    // We intentionally do not capture analytics during a client a fetch error. However, we do
    // return the successful state so external flows can record logs
    if (!$9c07754293fa47a8$var$isErrorOmitted(error) && (0, $dMM78.isClientFetchError)(error) && !(0, $4cTDP.fg)('bento_send_4xx_to_task_fail_gate_1')) {
        getExperienceDescription({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            wasSuccessful: $9c07754293fa47a8$var$isErrorOmitted(error),
            statusCode: error?.statusCode
        });
        return;
    }
    const reduceClassification = $9c07754293fa47a8$var$getReduceClassification();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const classification = reduceClassification(error);
    const { action: action, wasSuccessful: wasSuccessful } = $9c07754293fa47a8$var$classificationPayload[classification];
    (0, $3ibpe.sendExperienceAnalytics)({
        ...getExperienceDescription({
            wasSuccessful: wasSuccessful,
            statusCode: error?.statusCode
        }),
        action: action
    });
};

});
const $3a153a61cf6b691b$export$ff39ebd4bb12b718 = 201;
const $3a153a61cf6b691b$export$3288b14b6745c572 = 204;
const $3a153a61cf6b691b$export$9de493bcd9b1d977 = 400;
const $3a153a61cf6b691b$export$67d19e9a991baa07 = 401;
const $3a153a61cf6b691b$export$a3269a3914b007e3 = 403;
const $3a153a61cf6b691b$export$8bca792d963eb0ef = 404;
const $3a153a61cf6b691b$export$4a3cb39801694eee = 407;
const $3a153a61cf6b691b$export$fa405bbf47d510e2 = 408;
const $3a153a61cf6b691b$export$c09e7ea0fc79f34f = 409;
const $3a153a61cf6b691b$export$5244030134e99 = 412;
const $3a153a61cf6b691b$export$f90ac1df0b60853d = 413;
const $3a153a61cf6b691b$export$a447d0a965e16776 = 422;
const $3a153a61cf6b691b$export$3b48aba8957000cd = 426;
const $3a153a61cf6b691b$export$6763168a631449a2 = 429;
const $3a153a61cf6b691b$export$e813cd7045fcc98d = 500;
const $3a153a61cf6b691b$export$2ce38d41a306034e = 502;
const $3a153a61cf6b691b$export$974c37534b0191b1 = 503;
const $3a153a61cf6b691b$export$5400e8dddac3fcf3 = 504;

const $f17fa9e5c82da056$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $f17fa9e5c82da056$export$b48b3d1872522384 = 'taskFail';
const $f17fa9e5c82da056$export$aeeb00d0845d24d8 = 'taskAbort';


parcelRegister("e9OSL", function(module, exports) {
$parcel$export(module.exports, "useFieldExperienceTracking", () => $4a9350ba25b6d2c6$export$94c85d2216d24740);
$parcel$export(module.exports, "extractFirstErrorFromRelayError", () => $4a9350ba25b6d2c6$export$1e49248e7b3f98d6);
/**
 * Based on jira/src/packages/issue/issue-view/src/epics/experience-tracking/field-experience-tracking-epic.tsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $7wFII = parcelRequire("7wFII");

var $dMM78 = parcelRequire("dMM78");

var $bmoS1 = parcelRequire("bmoS1");

var $3ibpe = parcelRequire("3ibpe");

var $bNexr = parcelRequire("bNexr");

var $47pEa = parcelRequire("47pEa");
const $4a9350ba25b6d2c6$export$94c85d2216d24740 = ({ fieldId: fieldId })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const analyticsSource = (0, $bmoS1.useAnalyticsSource)();
    const getEditEventPayload = (0, $eJOHy.useCallback)(({ hasSuccess: hasSuccess, hasEdit: hasEdit, errorMessage: errorMessage, traceId: traceId, statusCode: statusCode, action: action })=>{
        const additionalAttributes = {};
        if (errorMessage != null) additionalAttributes.errorMessage = errorMessage;
        if (traceId != null) additionalAttributes.traceId = traceId;
        if (statusCode) additionalAttributes.statusCode = statusCode;
        return {
            experience: 'editIssue',
            analyticsSource: analyticsSource || 'unknown',
            application: application || null,
            edition: edition || null,
            wasExperienceSuccesful: hasSuccess,
            field: fieldId,
            hasEdit: hasEdit,
            additionalAttributes: additionalAttributes,
            action: action
        };
    }, [
        analyticsSource,
        application,
        edition,
        fieldId
    ]);
    const sendSubmitSucceededExperienceEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: true,
            hasEdit: true
        }));
    }, [
        getEditEventPayload
    ]);
    const sendSubmitFailedExperienceEvent = (0, $eJOHy.useCallback)((error)=>{
        if (!(0, $4cTDP.fg)('thor_add_taskabort_events_for_core_experiences') && (0, $dMM78.isClientFetchError)(error) || !error) return;
        const errorType = (0, $47pEa.default)(error);
        const match = error?.message?.match(/response: (\d+)/);
        const statusCode = match ? parseInt(match[1], 10) : undefined;
        if (statusCode && statusCode >= 400 && statusCode < 500) (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'issue.issue-view.editIssue',
                teamName: 'obsidian'
            },
            attributes: {
                experience: 'editIssue',
                analyticsSource: analyticsSource || 'unknown',
                application: application || null,
                edition: edition || null,
                wasExperienceSuccesful: false,
                field: fieldId,
                hasEdit: true,
                traceId: 'traceId' in error ? String(error?.traceId) : undefined
            }
        });
        let action;
        if ((0, $4cTDP.fg)('thor_add_taskabort_events_for_core_experiences')) action = (0, $7wFII.isAbortableError)(error) ? 'taskAbort' : 'taskFail';
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: (0, $4cTDP.fg)('thor_add_taskabort_events_for_core_experiences') ? (0, $7wFII.isAbortableError)(error) : errorType !== (0, $47pEa.SERVER_ERROR),
            hasEdit: true,
            errorMessage: 'statusCode' in error ? `${error.statusCode} - ${error.message}` : error.message,
            traceId: 'traceId' in error ? String(error?.traceId) : undefined,
            statusCode: 'statusCode' in error && typeof error?.statusCode === 'number' ? error.statusCode : undefined,
            action: action
        }));
    }, [
        getEditEventPayload,
        analyticsSource,
        application,
        edition,
        fieldId
    ]);
    const sendEditCancelExperienceEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $3ibpe.sendExperienceAnalytics)(getEditEventPayload({
            hasSuccess: true,
            hasEdit: false
        }));
    }, [
        getEditEventPayload
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            sendSubmitSucceededExperienceEvent: sendSubmitSucceededExperienceEvent,
            sendSubmitFailedExperienceEvent: sendSubmitFailedExperienceEvent,
            sendEditCancelExperienceEvent: sendEditCancelExperienceEvent
        }), [
        sendEditCancelExperienceEvent,
        sendSubmitFailedExperienceEvent,
        sendSubmitSucceededExperienceEvent
    ]);
};
const $4a9350ba25b6d2c6$export$1e49248e7b3f98d6 = (error)=>{
    if (!('source' in error)) return null;
    const errorSource = error.source;
    const errors = typeof errorSource === 'object' && errorSource != null && 'errors' in errorSource && errorSource.errors;
    const firstError = Array.isArray(errors) ? errors[0] : null;
    const statusCode = firstError?.extensions?.statusCode;
    const message = firstError?.message;
    return statusCode ? {
        statusCode: statusCode,
        message: message
    } : null;
};

});
parcelRegister("47pEa", function(module, exports) {
$parcel$export(module.exports, "SERVER_ERROR", () => $427c11e98f93775d$export$125ebd30471ac25c);
$parcel$export(module.exports, "default", () => $427c11e98f93775d$export$2e2bcd8739ae039);

var $14RSn = parcelRequire("14RSn");
const $427c11e98f93775d$export$125ebd30471ac25c = 'SERVER_ERROR';
const $427c11e98f93775d$export$558b92200f9a795 = 'VALIDATION_ERROR';
const $427c11e98f93775d$export$683dbe11f74cd161 = 'CONNECTIVITY_ERROR';
const $427c11e98f93775d$var$classifyFieldError = (error)=>{
    if (error instanceof (0, $14RSn.ValidationError)) return $427c11e98f93775d$export$558b92200f9a795;
    if (!(error instanceof (0, $14RSn.default))) return $427c11e98f93775d$export$683dbe11f74cd161;
    if (error.statusCode >= 400 && error.statusCode < 500) return $427c11e98f93775d$export$558b92200f9a795;
    return $427c11e98f93775d$export$125ebd30471ac25c;
};
var $427c11e98f93775d$export$2e2bcd8739ae039 = $427c11e98f93775d$var$classifyFieldError;

});


parcelRegister("Do7wq", function(module, exports) {
$parcel$export(module.exports, "TimezoneProvider", () => $a07f93c7a85ac681$export$2be0dd51d5c468b3);

var $eJOHy = parcelRequire("eJOHy");

var $4GTQB = parcelRequire("4GTQB");
const { Provider: $a07f93c7a85ac681$var$Provider, Consumer: $a07f93c7a85ac681$export$f45fbe45e97edb6f } = /*#__PURE__*/ (0, $eJOHy.createContext)((0, $4GTQB.SYDNEY_TIMEZONE));
const $a07f93c7a85ac681$export$2be0dd51d5c468b3 = (props)=>{
    const { children: children, value: value } = props;
    // Set default again if one attribute is undefined
    const memoizedValue = (0, $eJOHy.useMemo)(()=>value ?? (0, $4GTQB.getBrowserTimeZone)(), [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a07f93c7a85ac681$var$Provider, {
        value: memoizedValue
    }, children);
};

});

parcelRegister("7iDSo", function(module, exports) {
$parcel$export(module.exports, "default", () => $388dd53c88cf8151$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $hJRKH = parcelRequire("hJRKH");

var $eKZQP = parcelRequire("eKZQP");

var $coXKe = parcelRequire("coXKe");

var $d3a6V = parcelRequire("d3a6V");

var $44BYu = parcelRequire("44BYu");

var $df3FJ = parcelRequire("df3FJ");
const $388dd53c88cf8151$var$META_CONTAINER = 'META_CONTAINER';
const $388dd53c88cf8151$var$HISTORY_FEED_CONTAINER_TEST_ID = 'issue-history.ui.feed-container';
const $388dd53c88cf8151$var$HistoryItemsDI = (0, $df3FJ.default);
const $388dd53c88cf8151$var$IssueHistory = ({ issueKey: issueKey, sortOrder: sortOrder, HistoryItems: HistoryItems, IssueHistoryService: IssueHistoryService, GroupedActivityEntryComponent: GroupedActivityEntryComponent, issueViewRelayFragment: issueViewRelayFragment })=>{
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d3a6V.FeedContainer), {
        "data-testid": $388dd53c88cf8151$var$HISTORY_FEED_CONTAINER_TEST_ID
    }, userPreferredLayout === 'WIDE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($388dd53c88cf8151$var$MetaDataWrapper, {
        "data-testid": "issue-history.ui.meta-data"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKZQP.IssueViewMetaContainer), {
        key: $388dd53c88cf8151$var$META_CONTAINER,
        fragmentKey: issueViewRelayFragment ?? null
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueHistoryService, {
        issueKey: issueKey,
        sortOrder: sortOrder
    }, ({ loading: loading, loadingMore: loadingMore, hasMore: hasMore, loadMore: loadMore, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hJRKH.default), null);
        if (error) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HistoryItems, {
            history: data,
            hasMore: hasMore,
            isLoadingMore: loadingMore,
            onLoadMore: loadMore,
            sortOrder: sortOrder,
            GroupedActivityEntryComponent: GroupedActivityEntryComponent
        });
    }));
};
$388dd53c88cf8151$var$IssueHistory.defaultProps = {
    HistoryItems: $388dd53c88cf8151$var$HistoryItemsDI,
    IssueHistoryService: (0, $44BYu.default)
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $388dd53c88cf8151$var$MetaDataWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1n261g80 _2lx2vrvc _4cvr1y6m _1bah1yb4 _ae4v1fhb _18u0xmi2 _otyr1ejb _19pkmgjw",
            __cmplp.className
        ])
    });
});
var $388dd53c88cf8151$export$2e2bcd8739ae039 = $388dd53c88cf8151$var$IssueHistory;

});
parcelRegister("hJRKH", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d06febd710629e7$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $bmoS1 = parcelRequire("bmoS1");

var $jiTA8 = parcelRequire("jiTA8");

var $deIGy = parcelRequire("deIGy");

var $88U2v = parcelRequire("88U2v");

var $lPcSJ = parcelRequire("lPcSJ");

var $7KvBJ = parcelRequire("7KvBJ");

var $d1UTL = parcelRequire("d1UTL");
const $2d06febd710629e7$var$activityItemSkeleton = (isModal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d06febd710629e7$var$AvatarWrapper, {
        isModal: isModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1UTL.default), {
        isModal: isModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d06febd710629e7$var$Divider, {
        isModal: isModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7KvBJ.default), {
        isModal: isModal,
        paddingTop: 0,
        paddingBottom: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7KvBJ.default), {
        isModal: isModal,
        paddingTop: 1,
        paddingBottom: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $deIGy.default), {
        isModal: isModal,
        fontSize: 14,
        lineHeight: 16,
        intrusion: 250
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7KvBJ.default), {
        isModal: isModal,
        paddingTop: 4,
        paddingBottom: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $deIGy.default), {
        isModal: isModal,
        fontSize: 24,
        lineHeight: 24,
        intrusion: 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d06febd710629e7$var$FillerMask, {
        isModal: isModal
    })));
const $2d06febd710629e7$var$FeedSkeletonView = ()=>{
    const isModal = (0, $bmoS1.useIsModal)();
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)();
    const isLayered = isModal || isEmbedMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "activity-feed-skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d06febd710629e7$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lPcSJ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d06febd710629e7$var$FormContainer, {
        isModal: isLayered,
        paddingTop: 0,
        paddingBottom: 0
    }, $2d06febd710629e7$var$activityItemSkeleton(isLayered)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d06febd710629e7$var$FormContainer, {
        isModal: isLayered,
        paddingTop: 0,
        paddingBottom: 0
    }, $2d06febd710629e7$var$activityItemSkeleton(isLayered))));
};
var $2d06febd710629e7$export$2e2bcd8739ae039 = $2d06febd710629e7$var$FeedSkeletonView;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2d06febd710629e7$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $88U2v.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $2d06febd710629e7$var$FormContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $7KvBJ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $2d06febd710629e7$var$Divider = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $lPcSJ.CleanDiv), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbrdoj _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $2d06febd710629e7$var$FillerMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $lPcSJ.CleanDiv), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3iqslr",
            __cmplp.className
        ])
    });
});
const $2d06febd710629e7$var$AvatarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1ylp _1o9zidpf",
            __cmplp.isModal ? "_n7zltxt0" : "_n7zltuud",
            __cmplp.className
        ])
    });
});

});
parcelRegister("deIGy", function(module, exports) {
$parcel$export(module.exports, "default", () => $02e75118e387bf16$export$2e2bcd8739ae039);
/* text-line-mask-view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $02e75118e387bf16$var$SC1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1sswcfi": (0, $awdRS.default)(`${__cmplp.fontSize}px`),
            "--_172l934": (0, $awdRS.default)(__cmplp.intrusion, "px"),
            "--_1o6j0d": (0, $awdRS.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _4t3i1l57",
            __cmplp.isModal ? "_1s7z12nn" : "_1s7z1cpt",
            __cmplp.isModal ? "_x3do12pv" : "_x3do16rq",
            __cmplp.isModal ? "_n7zl12pv" : "_n7zl16rq",
            __cmplp.className
        ])
    });
});
var $02e75118e387bf16$export$2e2bcd8739ae039 = $02e75118e387bf16$var$SC1;

});

parcelRegister("88U2v", function(module, exports) {
$parcel$export(module.exports, "default", () => $774221362796f4e2$export$2e2bcd8739ae039);
/* skeleton-container-view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $774221362796f4e2$var$SC1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
var $774221362796f4e2$export$2e2bcd8739ae039 = $774221362796f4e2$var$SC1;

});

parcelRegister("lPcSJ", function(module, exports) {
$parcel$export(module.exports, "CleanDiv", () => $84ec9e8f75f7d0da$export$e2099645cdcaf24c);
$parcel$export(module.exports, "default", () => $84ec9e8f75f7d0da$export$2e2bcd8739ae039);
/* skeleton-background-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $84ec9e8f75f7d0da$var$shimmer = null;
const $84ec9e8f75f7d0da$export$e2099645cdcaf24c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1itkglyw",
            __cmplp.isModal ? "_bfhk1bhr" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $84ec9e8f75f7d0da$var$SC1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkm7j4 _1itki374 _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.className
        ])
    });
});
var $84ec9e8f75f7d0da$export$2e2bcd8739ae039 = $84ec9e8f75f7d0da$var$SC1;

});

parcelRegister("7KvBJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b484770a680dd67$export$2e2bcd8739ae039);
/* container-mask-view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $5b484770a680dd67$var$SC1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, paddingTop: paddingTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1cgzp5c": (0, $awdRS.default)(__cmplp.paddingTop, "px"),
            "--_1ntldin": (0, $awdRS.default)(__cmplp.paddingBottom, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1bsb1osq",
            __cmplp.isModal ? "_x3doostm" : "_x3do3rsf",
            __cmplp.isModal ? "_n7zlfiih" : "_n7zlh1it",
            __cmplp.className
        ])
    });
});
var $5b484770a680dd67$export$2e2bcd8739ae039 = $5b484770a680dd67$var$SC1;

});

parcelRegister("d1UTL", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b7a00e4682bf80d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $8b7a00e4682bf80d$var$Avatar = ({ isModal: isModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("mask", {
        id: "circle-cutout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "0",
        y: "0",
        width: "40",
        height: "40",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "18",
        cy: "18",
        r: "16",
        fill: "black"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "0",
        y: "0",
        width: "40",
        height: "40",
        mask: "url(#circle-cutout)",
        fill: isModal ? "var(--ds-surface-overlay, #FFFFFF)" : "var(--ds-surface, #FFFFFF)"
    }));
var $8b7a00e4682bf80d$export$2e2bcd8739ae039 = $8b7a00e4682bf80d$var$Avatar;

});


parcelRegister("eKZQP", function(module, exports) {
$parcel$export(module.exports, "IssueViewMetaContainer", () => $9cd1ee17ed417f7f$export$dab313962088f323);

var $62Mym = parcelRequire("62Mym");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $35aJB = parcelRequire("35aJB");

var $kygwf = parcelRequire("kygwf");

var $6nrjS = parcelRequire("6nrjS");

var $coXKe = parcelRequire("coXKe");

var $4EKqI = parcelRequire("4EKqI");
const $9cd1ee17ed417f7f$export$dab313962088f323 = /*#__PURE__*/ (0, $eJOHy.memo)(({ fragmentKey: fragmentKey })=>{
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const data = (0, $j4oe4.useFragment)((0, $62Mym.default), fragmentKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "issue-timestamps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9cd1ee17ed417f7f$var$containerStyles,
            userPreferredLayout === 'WIDE' && $9cd1ee17ed417f7f$var$wideViewStyle
        ]
    }, data?.createdField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $35aJB.IssueViewCreatedDateField), {
        fragmentKey: data.createdField
    }), data?.updatedField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6nrjS.IssueViewUpdatedDateField), {
        fragmentKey: data.updatedField
    }), data?.resolutionDateField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kygwf.IssueViewResolvedDateField), {
        fragmentKey: data.resolutionDateField
    })));
});
const $9cd1ee17ed417f7f$var$containerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.050',
    marginRight: 'space.200',
    flex: 1,
    paddingLeft: 'space.150'
});
const $9cd1ee17ed417f7f$var$wideViewStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    gap: 'space.200'
});

});
parcelRegister("62Mym", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd012b8bb3ce9619$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<29db414d6afefaaa1b7b6c8068c018e5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dd012b8bb3ce9619$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutMetaContainer_IssueViewMetaContainer",
    "selections": [
        {
            "concreteType": "JiraDateTimePickerField",
            "kind": "LinkedField",
            "name": "createdField",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewLayoutMetaCreatedDateField_IssueViewCreatedDateField"
                }
            ]
        },
        {
            "concreteType": "JiraDateTimePickerField",
            "kind": "LinkedField",
            "name": "updatedField",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField"
                }
            ]
        },
        {
            "concreteType": "JiraDateTimePickerField",
            "kind": "LinkedField",
            "name": "resolutionDateField",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$dd012b8bb3ce9619$var$node.hash = "a71ce3a68365ca196ff43c7f039c2c97";
var $dd012b8bb3ce9619$export$2e2bcd8739ae039 = $dd012b8bb3ce9619$var$node;

});

parcelRegister("35aJB", function(module, exports) {
$parcel$export(module.exports, "IssueViewCreatedDateField", () => $7d03ba4559b853ba$export$48fee9c917da958a);

var $7V6Mo = parcelRequire("7V6Mo");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $706eG = parcelRequire("706eG");
const $7d03ba4559b853ba$export$48fee9c917da958a = ({ fragmentKey: fragmentKey })=>{
    const data = (0, $j4oe4.useFragment)((0, $7V6Mo.default), fragmentKey);
    if (!data.dateTime) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $706eG.CreatedDate), {
        date: data.dateTime
    });
};

});
parcelRegister("7V6Mo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2829d783188b6bb3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e8462ff62978ed4316847e9c28e5565>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2829d783188b6bb3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutMetaCreatedDateField_IssueViewCreatedDateField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$2829d783188b6bb3$var$node.hash = "7a873820e7f681cece55adec6c8641e3";
var $2829d783188b6bb3$export$2e2bcd8739ae039 = $2829d783188b6bb3$var$node;

});

parcelRegister("706eG", function(module, exports) {
$parcel$export(module.exports, "CreatedDate", () => $c7122f2aac60cdda$export$71ddacaac65a33a4);

var $eJOHy = parcelRequire("eJOHy");

var $1qbKn = parcelRequire("1qbKn");

var $lRq8t = parcelRequire("lRq8t");

var $9n221 = parcelRequire("9n221");

var $cer50 = parcelRequire("cer50");
const $c7122f2aac60cdda$export$71ddacaac65a33a4 = ({ date: date })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return date !== null && date !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorBoundaryFlag), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9n221.default), {
        testId: "created-date.ui.read.meta-date",
        date: date,
        text: formatMessage((0, $cer50.default).createdLabel)
    })) : null;
};

});
parcelRegister("9n221", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0d82a5e8b4b51c6$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cdbP5 = parcelRequire("cdbP5");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $9aHSR = parcelRequire("9aHSR");

var $bJscI = parcelRequire("bJscI");
const $f0d82a5e8b4b51c6$var$MetaDateOld = (props)=>{
    const { text: text, date: date, testId: testId } = props;
    if (date === undefined || date === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        testId: testId,
        xcss: $f0d82a5e8b4b51c6$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f0d82a5e8b4b51c6$var$TextSpan, null, text, "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9aHSR.default), {
        value: date,
        extraStyles: $f0d82a5e8b4b51c6$var$TimestampStyles,
        tooltipPosition: "right"
    })));
};
const $f0d82a5e8b4b51c6$var$MetaDateMemo = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const { text: text, date: date, testId: testId } = props;
    if (date === undefined || date === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        testId: testId,
        xcss: $f0d82a5e8b4b51c6$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f0d82a5e8b4b51c6$var$TextSpan, null, text, "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9aHSR.default), {
        value: date,
        extraStyles: $f0d82a5e8b4b51c6$var$TimestampStyles,
        tooltipPosition: "right"
    })));
});
const $f0d82a5e8b4b51c6$var$MetaDate = (0, $bJscI.componentWithFG)('issue_view_timestamp_perf', $f0d82a5e8b4b51c6$var$MetaDateMemo, $f0d82a5e8b4b51c6$var$MetaDateOld);
var $f0d82a5e8b4b51c6$export$2e2bcd8739ae039 = $f0d82a5e8b4b51c6$var$MetaDate;
const $f0d82a5e8b4b51c6$var$containerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $f0d82a5e8b4b51c6$var$TextSpan = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaz1gjq _ca0qv77o _o5721q9c _19pkidpf _vwz41clk",
            __cmplp.className
        ])
    });
});
$f0d82a5e8b4b51c6$var$TextSpan.displayName = 'TextSpan';
const $f0d82a5e8b4b51c6$var$TimestampStyles = {
    whenDisplaySettingSwitchable: (0, $cdbP5.css)({
        '&:hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    })
};

});

parcelRegister("cer50", function(module, exports) {
$parcel$export(module.exports, "default", () => $a54fc737710c3235$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a54fc737710c3235$var$messages = (0, $7qGN1.defineMessages)({
    createdLabel: {
        "id": "created-date.read.created-label",
        "defaultMessage": "Created"
    }
});
var $a54fc737710c3235$export$2e2bcd8739ae039 = $a54fc737710c3235$var$messages;

});



parcelRegister("kygwf", function(module, exports) {
$parcel$export(module.exports, "IssueViewResolvedDateField", () => $f490aa1335319c14$export$21e5ab19e5b551d5);

var $dWblf = parcelRequire("dWblf");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $379xF = parcelRequire("379xF");
const $f490aa1335319c14$export$21e5ab19e5b551d5 = ({ fragmentKey: fragmentKey })=>{
    const data = (0, $j4oe4.useFragment)((0, $dWblf.default), fragmentKey);
    if (!data.dateTime) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $379xF.ResolvedDate), {
        date: data.dateTime
    });
};

});
parcelRegister("dWblf", function(module, exports) {
$parcel$export(module.exports, "default", () => $89524daa2d9f9dba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d77eb9fc84b20aecb90697ee7911ebab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $89524daa2d9f9dba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutMetaResolvedDateField_IssueViewResolvedDateField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$89524daa2d9f9dba$var$node.hash = "6a930131aee2a1313fe4a8e084c7a7ab";
var $89524daa2d9f9dba$export$2e2bcd8739ae039 = $89524daa2d9f9dba$var$node;

});

parcelRegister("379xF", function(module, exports) {
$parcel$export(module.exports, "ResolvedDate", () => $8d28978d143ce9ef$export$a30ef0630a43e5ae);

var $eJOHy = parcelRequire("eJOHy");

var $1qbKn = parcelRequire("1qbKn");

var $lRq8t = parcelRequire("lRq8t");

var $9n221 = parcelRequire("9n221");

var $ailgQ = parcelRequire("ailgQ");
const $8d28978d143ce9ef$export$a30ef0630a43e5ae = ({ date: date })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return date !== null && date !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorBoundaryFlag), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9n221.default), {
        testId: "resolved-date.ui.read.meta-date",
        date: date,
        text: formatMessage((0, $ailgQ.default).resolvedLabel)
    })) : null;
};

});
parcelRegister("ailgQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a7cce6fec6d50bf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4a7cce6fec6d50bf$var$messages = (0, $7qGN1.defineMessages)({
    resolvedLabel: {
        "id": "resolved-date.read.resolved-label",
        "defaultMessage": "Resolved"
    }
});
var $4a7cce6fec6d50bf$export$2e2bcd8739ae039 = $4a7cce6fec6d50bf$var$messages;

});



parcelRegister("6nrjS", function(module, exports) {
$parcel$export(module.exports, "IssueViewUpdatedDateField", () => $4690dbaf7ed3aa26$export$63d09e52cf6b72c3);

var $6A2Qm = parcelRequire("6A2Qm");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $50Myt = parcelRequire("50Myt");
const $4690dbaf7ed3aa26$export$63d09e52cf6b72c3 = ({ fragmentKey: fragmentKey })=>{
    const data = (0, $j4oe4.useFragment)((0, $6A2Qm.default), fragmentKey);
    if (!data.dateTime) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $50Myt.UpdatedDate), {
        date: data.dateTime
    });
};

});
parcelRegister("6A2Qm", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba679f511e4ed4ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1fa60d0b1a3a8ed0caa871a0c71dbfdc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba679f511e4ed4ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "dateTime"
        }
    ],
    "type": "JiraDateTimePickerField"
};
$ba679f511e4ed4ea$var$node.hash = "34f406f9cda9f12c9ce457379082edbd";
var $ba679f511e4ed4ea$export$2e2bcd8739ae039 = $ba679f511e4ed4ea$var$node;

});

parcelRegister("50Myt", function(module, exports) {
$parcel$export(module.exports, "UpdatedDate", () => $6a92c073a986cb09$export$b35f52e6703bf6e5);

var $eJOHy = parcelRequire("eJOHy");

var $1qbKn = parcelRequire("1qbKn");

var $lRq8t = parcelRequire("lRq8t");

var $9n221 = parcelRequire("9n221");

var $5Ary0 = parcelRequire("5Ary0");
const $6a92c073a986cb09$export$b35f52e6703bf6e5 = ({ date: date })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return date !== null && date !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorBoundaryFlag), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9n221.default), {
        testId: "updated-date.ui.read.meta-date",
        date: date,
        text: formatMessage((0, $5Ary0.default).updatedLabel)
    })) : null;
};

});
parcelRegister("5Ary0", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b52a9933eff95eb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1b52a9933eff95eb$var$messages = (0, $7qGN1.defineMessages)({
    updatedLabel: {
        "id": "updated-date.read.updated-label",
        "defaultMessage": "Updated"
    }
});
var $1b52a9933eff95eb$export$2e2bcd8739ae039 = $1b52a9933eff95eb$var$messages;

});




parcelRegister("44BYu", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb27d57f6f96fc8a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $jGtPF = parcelRequire("jGtPF");

var $bNexr = parcelRequire("bNexr");

var $l5e25 = parcelRequire("l5e25");

var $jg1KW = parcelRequire("jg1KW");

var $4TOFo = parcelRequire("4TOFo");
const $fb27d57f6f96fc8a$var$NUM_INITIAL_ITEMS_TO_LOAD_FOR_POST_LOAD_ACTIONS = 100;
const $fb27d57f6f96fc8a$var$NUM_PAGED_ITEMS_TO_LOAD = 100;
const $fb27d57f6f96fc8a$export$53ac33307b5acee9 = (issueKey)=>({
        status: 'IDLE',
        issueKey: issueKey,
        historyItems: [],
        nextPageStartIndex: 0
    });
const $fb27d57f6f96fc8a$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case 'FETCH_PAGE_SUCCESS':
            // Result is stale if issue key changed in the meantime.
            if (action.issueKey !== state.issueKey) return state;
            return {
                ...state,
                status: 'IDLE',
                nextPageStartIndex: action.response.isLastPage ? null : action.response.nextPageStartIndex,
                historyItems: [
                    ...state.historyItems,
                    ...action.response.history
                ]
            };
        case 'FETCH_PAGE_FAILURE':
            // Result is stale if issue key changed in the meantime.
            if (action.issueKey !== state.issueKey) return state;
            return {
                ...state,
                status: 'ERROR'
            };
        case 'NEXT_PAGE_REQUESTED':
            return {
                ...state,
                status: 'LOADING_SUBSEQUENT_PAGE'
            };
        case 'CHANGE_ISSUE_REQUESTED':
            return {
                issueKey: action.issueKey,
                status: 'LOADING_FIRST_PAGE',
                historyItems: [],
                nextPageStartIndex: 0
            };
        default:
            // prettier-ignore
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action.type;
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            throw new Error(`Unknown action type in issue history reducer: ${action.type}`);
    }
};
const $fb27d57f6f96fc8a$export$3343632372cec89d = (issueKey, sortOrder)=>{
    const [state, dispatch] = (0, $eJOHy.useReducer)($fb27d57f6f96fc8a$export$1650419e431d3ba3, $fb27d57f6f96fc8a$export$53ac33307b5acee9(issueKey));
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const fetchPage = (0, $eJOHy.useCallback)(async (pageStartIndex, pageSize)=>{
        try {
            const response = await (0, $jg1KW.getIssueHistory)(issueKey, pageStartIndex, sortOrder, pageSize);
            (0, $jGtPF.sendExperienceAnalytics)({
                getExperienceDescription: ({ wasSuccessful: wasSuccessful })=>(0, $l5e25.experienceDescription)({
                        experience: 'issueHistory',
                        action: 'FETCH_PAGE',
                        analyticsSource: 'issueHistoryFetch',
                        wasSuccessful: wasSuccessful,
                        projectType: projectType
                    })
            });
            dispatch({
                type: 'FETCH_PAGE_SUCCESS',
                response: response,
                issueKey: issueKey
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.activity.history.fetch-history-page', 'Query returned errors', error);
            (0, $jGtPF.sendExperienceAnalytics)({
                getExperienceDescription: ({ wasSuccessful: wasSuccessful, statusCode: statusCode })=>(0, $l5e25.experienceDescription)({
                        experience: 'issueHistory',
                        action: 'FETCH_PAGE',
                        analyticsSource: 'issueHistoryFetch',
                        wasSuccessful: wasSuccessful,
                        projectType: projectType,
                        statusCode: statusCode,
                        errorMessage: error?.message || 'UNKNOWN_ERROR',
                        traceId: error?.traceId || ''
                    }),
                error: error
            });
            dispatch({
                type: 'FETCH_PAGE_FAILURE',
                issueKey: issueKey
            });
        }
    }, [
        issueKey,
        sortOrder,
        projectType
    ]);
    (0, $eJOHy.useEffect)(()=>{
        dispatch({
            type: 'CHANGE_ISSUE_REQUESTED',
            issueKey: issueKey
        });
        fetchPage(0, $fb27d57f6f96fc8a$var$NUM_INITIAL_ITEMS_TO_LOAD_FOR_POST_LOAD_ACTIONS);
    }, [
        fetchPage,
        issueKey
    ]);
    const loadMore = ()=>{
        const { status: status, nextPageStartIndex: nextPageStartIndex } = state;
        if (status === 'IDLE' && nextPageStartIndex !== null) {
            dispatch({
                type: 'NEXT_PAGE_REQUESTED'
            });
            fetchPage(nextPageStartIndex, $fb27d57f6f96fc8a$var$NUM_PAGED_ITEMS_TO_LOAD);
        }
    };
    const { status: status, historyItems: historyItems, nextPageStartIndex: nextPageStartIndex } = state;
    return {
        loading: status === 'LOADING_FIRST_PAGE',
        loadingMore: status === 'LOADING_SUBSEQUENT_PAGE',
        error: status === 'ERROR',
        hasMore: nextPageStartIndex !== null,
        data: (0, $4TOFo.groupHistoryItems)(historyItems),
        loadMore: loadMore
    };
};
const $fb27d57f6f96fc8a$var$IssueHistoryService = ({ issueKey: issueKey, sortOrder: sortOrder, children: children })=>children($fb27d57f6f96fc8a$export$3343632372cec89d(issueKey, sortOrder));
var $fb27d57f6f96fc8a$export$2e2bcd8739ae039 = $fb27d57f6f96fc8a$var$IssueHistoryService;

});
parcelRegister("l5e25", function(module, exports) {
$parcel$export(module.exports, "experienceDescription", () => $b2b2ac3eb6b004a9$export$b80ef1f910664ac4);

var $aYncF = parcelRequire("aYncF");

var $lBYgs = parcelRequire("lBYgs");

var $cblKs = parcelRequire("cblKs");
const $b2b2ac3eb6b004a9$export$b80ef1f910664ac4 = ({ experience: experience, wasSuccessful: wasSuccessful, action: action, analyticsSource: analyticsSource, projectType: projectType, errorMessage: errorMessage, statusCode: statusCode, isEventOccurredAtSelected: isEventOccurredAtSelected, traceId: traceId, frameworkType: frameworkType })=>{
    let application = null;
    let edition = null;
    if (projectType !== undefined) try {
        const { appEditions: appEditions } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
        application = (0, $lBYgs.getApplicationForProject)(projectType);
        edition = (0, $cblKs.getEdition)(application, appEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // application and edition already default to null.
    }
    return {
        experience: experience,
        wasExperienceSuccesful: wasSuccessful,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: {
            action: action,
            ...typeof statusCode !== 'undefined' ? {
                statusCode: statusCode
            } : null,
            ...errorMessage !== undefined ? {
                errorMessage: errorMessage
            } : null,
            ...isEventOccurredAtSelected !== undefined ? {
                isEventOccurredAtSelected: isEventOccurredAtSelected
            } : null,
            ...traceId !== undefined ? {
                traceId: traceId
            } : null,
            ...frameworkType !== undefined ? {
                frameworkType: frameworkType
            } : null
        }
    };
};

});

parcelRegister("jg1KW", function(module, exports) {
$parcel$export(module.exports, "fetchIssueCreatedInfo", () => $c96720e374dfc9f2$export$b071d2800a3c3856);
$parcel$export(module.exports, "getIssueHistory", () => $c96720e374dfc9f2$export$efacec3410a85dc7);

var $keOPi = parcelRequire("keOPi");

var $6rzJr = parcelRequire("6rzJr");


var $88uGO = parcelRequire("88uGO");
const $c96720e374dfc9f2$export$d245426099cf4980 = `
    query IssueHistoryQuery($issueKey: String!, $startAt: Long, $maxResults: Int, $orderBy: String) {
        viewIssue(issueKey: $issueKey) {
            history(orderBy: $orderBy, startAt: $startAt, maxResults: $maxResults) {
                isLast
                totalCount
                startIndex
                nodes {
                    fieldId
                    fieldType
                    fieldSchema {
                        type
                        customFieldType
                    }
                    timestamp
                    actor {
                        avatarUrls {
                            large
                        }
                        displayName
                        accountId
                    }
                    fieldDisplayName
                    isDueToRedaction
					isDueToRedactionRestore
                    from {
                        ... on GenericFieldValue {
                            displayValue
                            value
                        }
                        ... on AssigneeFieldValue {
                            displayValue
                            value
                            avatarUrl
                        }
                        ... on PriorityFieldValue {
                            displayValue
                            value
                            iconUrl
                        }
                        ... on StatusFieldValue {
                            displayValue
                            value
                            categoryId
                        }
                        ... on WorkLogFieldValue {
                            displayValue
                            value
                            worklog {
                                id
                                timeSpent
                            }
                        }
                        ... on RespondersFieldValue {
                            displayValue
                            value
                            responders {
                                ari
                                name
                                type
                                avatarUrl
                            }
                        }
                    }
                    to {
                        ... on GenericFieldValue {
                            displayValue
                            value
                        }
                        ... on AssigneeFieldValue {
                            displayValue
                            value
                            avatarUrl
                        }
                        ... on PriorityFieldValue {
                            displayValue
                            value
                            iconUrl
                        }
                        ... on StatusFieldValue {
                            displayValue
                            value
                            categoryId
                        }
                        ... on WorkLogFieldValue {
                            displayValue
                            value
                            worklog {
                                id
                                timeSpent
                            }
                        }
                        ... on RespondersFieldValue {
                            displayValue
                            value
                            responders {
                                ari
                                name
                                type
                                avatarUrl
                            }
                        }
                    }
                }
            }
        }
    }
`;
const $c96720e374dfc9f2$var$getIssueCreatedUrl = (issueKey)=>`/rest/api/3/issue/${issueKey}?fields=creator,created`;
const $c96720e374dfc9f2$export$b071d2800a3c3856 = (issueKey)=>(0, $keOPi.performIssueGetRequest)($c96720e374dfc9f2$var$getIssueCreatedUrl(issueKey), undefined, 'issue-actions/issue-history/src/services/issue-history/history-item-generator').then((0, $88uGO.transformCreateInfoResponse));
const $c96720e374dfc9f2$export$23a326979994188b = async (issueKey, startAt, sortMode, pageSize)=>{
    const client = (0, $6rzJr.getClient)('issue-actions/issue-history/src/history-item-generator/index');
    // @ts-expect-error - Property 'data' does not exist on type 'unknown'. | Property 'errors' does not exist on type 'unknown'.
    const { data: data, errors: errors } = await client.query({
        query: $c96720e374dfc9f2$export$d245426099cf4980,
        variables: {
            issueKey: issueKey,
            startAt: startAt,
            maxResults: pageSize,
            orderBy: sortMode === (0, $b3f7436b1db296f5$export$e86669f498228fff) ? 'created' : '-created'
        }
    });
    if (errors) throw new Error(`Errors returned from IssueHistoryQuery result: ${errors// @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
    .map((x)=>x.message).join(', ')}`);
    if (!data) throw new Error('Unexpected empty data object received from IssueHistoryQuery result with no errors');
    return (0, $88uGO.transformGraphQlResponse)(data, pageSize);
};
const $c96720e374dfc9f2$export$efacec3410a85dc7 = async (issueKey, startAt, sortMode, pageSize)=>{
    if (startAt === 0 && sortMode === (0, $b3f7436b1db296f5$export$e86669f498228fff)) {
        const [issueHistory, createInfo] = await Promise.all([
            $c96720e374dfc9f2$export$23a326979994188b(issueKey, startAt, sortMode, pageSize),
            $c96720e374dfc9f2$export$b071d2800a3c3856(issueKey)
        ]);
        return {
            ...issueHistory,
            history: [
                createInfo,
                ...issueHistory.history
            ]
        };
    }
    const issueHistory = await $c96720e374dfc9f2$export$23a326979994188b(issueKey, startAt, sortMode, pageSize);
    if (sortMode === (0, $b3f7436b1db296f5$export$eda5fe8da1abb04c) && issueHistory.isLastPage) {
        const createInfo = await $c96720e374dfc9f2$export$b071d2800a3c3856(issueKey);
        return {
            ...issueHistory,
            history: [
                ...issueHistory.history,
                createInfo
            ]
        };
    }
    return issueHistory;
};

});
// Activity sort order
const $b3f7436b1db296f5$export$eda5fe8da1abb04c = 'NEWEST_FIRST';
const $b3f7436b1db296f5$export$e86669f498228fff = 'OLDEST_FIRST';

parcelRegister("88uGO", function(module, exports) {
$parcel$export(module.exports, "transformChangelogItem", () => $24675b39e1fc3320$export$a32d3e40a269588f);
$parcel$export(module.exports, "transformCreateInfoResponse", () => $24675b39e1fc3320$export$5135eb3afa736a29);
$parcel$export(module.exports, "transformGraphQlResponse", () => $24675b39e1fc3320$export$716425a07890b235);

var $8dH3d = parcelRequire("8dH3d");

var $kQ82p = parcelRequire("kQ82p");

var $3T7mg = parcelRequire("3T7mg");

var $jx0Vw = parcelRequire("jx0Vw");

var $cxKOj = parcelRequire("cxKOj");

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

const $24675b39e1fc3320$var$transformRestActor = (actor)=>actor ? {
        avatarUrl: actor.avatarUrls['48x48'],
        displayName: actor.displayName,
        accountId: actor.accountId
    } : null;
const $24675b39e1fc3320$var$transformGraphQlActor = (actor)=>actor ? {
        avatarUrl: actor.avatarUrls.large,
        displayName: actor.displayName,
        accountId: actor.accountId
    } : null;
const $24675b39e1fc3320$export$a32d3e40a269588f = (item)=>{
    const { fieldSchema: fieldSchema, fieldId: fieldId, fieldType: fieldType, fieldDisplayName: fieldDisplayName, timestamp: changelogTimestamp, actor: changelogActor, isDueToRedaction: isDueToRedaction, isDueToRedactionRestore: isDueToRedactionRestore } = item;
    // so we don't need `if (from)...` on every branch
    let { from: from, to: to } = item;
    // @ts-expect-error - TS2322 - Type 'FieldValueGraphQlResponse | {}' is not assignable to type 'FieldValueGraphQlResponse | null | undefined'.
    from = from || {};
    // @ts-expect-error - TS2322 - Type 'FieldValueGraphQlResponse | {}' is not assignable to type 'FieldValueGraphQlResponse | undefined'.
    to = to || {};
    const actor = $24675b39e1fc3320$var$transformGraphQlActor(changelogActor);
    const timestamp = typeof changelogTimestamp === 'string' ? (0, $kQ82p.default)(changelogTimestamp) : (0, $3T7mg.default)(changelogTimestamp);
    if ((0, $4cTDP.fg)('enable_redaction_support_in_jira_issue_view')) {
        if (isDueToRedaction) return {
            fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
            type: (0, $46dbc1f137614648$export$53027079dd8d1476),
            actor: actor,
            timestamp: timestamp,
            field: fieldDisplayName
        };
        if (isDueToRedactionRestore && (0, $4cTDP.fg)('enable_redaction_restoration_history_view')) return {
            fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
            type: (0, $46dbc1f137614648$export$ac51718b2bcd56c9),
            actor: actor,
            timestamp: timestamp,
            field: fieldDisplayName,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            fromValue: from?.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            toValue: to?.displayValue
        };
    }
    if ((fieldType === 'jira' && fieldId === 'description' || fieldType === 'custom' && fieldSchema?.customFieldType === (0, $3mZMJ.TEXT_AREA_CF_TYPE)) && (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return {
        fieldType: fieldType,
        type: (0, $46dbc1f137614648$export$771d231cdd66c0e2),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from?.displayValue,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        toValue: to?.displayValue
    };
    if (fieldType === 'jira' && fieldId === 'assignee') return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$f1970b3f16b29de5),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2322 - Type '{ displayName: string | null; avatarUrl: string | undefined; accountId: string | undefined; } | null' is not assignable to type 'User | null'. | TS2533 - Object is possibly 'null' or 'undefined'.
        fromUser: !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(from.displayValue) ? {
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            displayName: from.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            avatarUrl: from.avatarUrl,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            accountId: from.accountId
        } : null,
        // @ts-expect-error - TS2322 - Type '{ displayName: string | null; avatarUrl: string | undefined; accountId: string | undefined; } | null' is not assignable to type 'User | null'. | TS2532 - Object is possibly 'undefined'.
        toUser: !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(to.displayValue) ? {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            displayName: to.displayValue,
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            avatarUrl: to.avatarUrl,
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            accountId: to.accountId
        } : null
    };
    if (fieldType === 'jira' && fieldId === 'status') return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$7566709b8f78aeb1),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2322 - Type '{ name: string | null; statusCategory: StatusCategory; } | null' is not assignable to type 'Status | null'. | TS2533 - Object is possibly 'null' or 'undefined'.
        fromStatus: !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(from.displayValue) ? {
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            name: from.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            statusCategory: (0, $jx0Vw.statusCategoryForId)(from.categoryId)
        } : null,
        // @ts-expect-error - TS2322 - Type '{ name: string | null; statusCategory: StatusCategory; } | null' is not assignable to type 'Status | null'. | TS2532 - Object is possibly 'undefined'.
        toStatus: !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(to.displayValue) ? {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            name: to.displayValue,
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            statusCategory: (0, $jx0Vw.statusCategoryForId)(to.categoryId)
        } : null
    };
    if (fieldType === 'jira' && fieldId === 'comment') return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$53e9822dbffbb9bc),
        actor: actor,
        timestamp: timestamp
    };
    if (fieldType === 'jira' && fieldId === 'softArchived') return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$5fd7b626c41a75e3),
        actor: actor,
        timestamp: timestamp,
        fromValue: from?.value
    };
    if (fieldType === 'jira' && fieldId === 'attachment') return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$107cfebb0511df9e),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2532 - Object is possibly 'undefined'.
        filename: from.displayValue ?? to.displayValue ?? '',
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        action: !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(from.displayValue) ? (0, $46dbc1f137614648$export$4427798ee4002a4d) : (0, $46dbc1f137614648$export$8648a9c7bbb05a59)
    };
    if (fieldType === 'jira' && fieldId === 'priority') return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$e0672bc3e33c4c82),
        actor: actor,
        timestamp: timestamp,
        fromPriority: {
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            iconUrl: from.iconUrl || '',
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            name: from.displayValue || ''
        },
        toPriority: {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            iconUrl: to.iconUrl || '',
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            name: to.displayValue || ''
        }
    };
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    if (fieldType === 'jira' && fieldDisplayName === 'WorklogId' && to.worklog) return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$33b21ab9c6fec8d0),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        comment: to.worklog.comment,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        timeSpent: to.worklog.timeSpent
    };
    if (fieldType === 'jira' && fieldDisplayName === 'IssueParentAssociation') return {
        fieldType: fieldType,
        type: (0, $46dbc1f137614648$export$edaa98b0c4bb1ef3),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from.displayValue,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toValue: to.displayValue
    };
    if (fieldType === 'jira' && (fieldId === 'timespent' || fieldId === 'timeestimate' || fieldId === 'timeoriginalestimate')) return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$37c97aab53f01e4c),
        actor: actor,
        field: fieldDisplayName,
        timestamp: timestamp,
        timeTrackingConfig: item.timeTrackingConfig ? item.timeTrackingConfig : null,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        fromTime: parseInt(from.value, 10),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        toTime: parseInt(to.value, 10)
    };
    if (fieldType === 'custom' && fieldSchema && fieldSchema.customFieldType === 'com.atlassian.jira.plugin.system.customfieldtypes:float') return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$b45ef25f7a696e98),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(from.displayValue) ? Number(from.displayValue) : null,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        toValue: !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(to.displayValue) ? Number(to.displayValue) : null
    };
    if ((fieldType === 'jira' || fieldType === 'custom') && fieldSchema && fieldSchema.type === 'date' || fieldType === 'custom' && fieldSchema && fieldSchema.type === 'datetime') // handles the default due date and custom date/datetime fields for the history log.
    return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$ccf54e923acb91b2),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromDate: from.value,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toDate: to.value,
        fieldSchema: fieldSchema.type
    };
    if (fieldType === 'custom' && fieldSchema?.customFieldType === (0, $3mZMJ.RESPONDERS_CF_TYPE)) return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$69a77f5e7c42a227),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from.responders || null,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toValue: to.responders || null
    };
    if (fieldType === 'custom' && fieldSchema?.customFieldType === (0, $3mZMJ.SERVICE_ENTITY_CF_TYPE)) return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$bf9ba14f4fe0e36a),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        fromValue: from?.value || null,
        toValue: to?.value || null,
        fromDisplayValue: from?.displayValue || null,
        toDisplayValue: to?.displayValue || null
    };
    if (fieldType === 'jira' && fieldId === 'dataClassification') return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$844d56dab10d6cfb),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        fromClassification: from?.displayValue ? {
            name: from?.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            color: from?.color,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            guidelines: from?.guidelines
        } : null,
        toClassification: to?.displayValue ? {
            name: to?.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            color: to?.color,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            guidelines: to?.guidelines
        } : null
    };
    if (fieldType === 'jira' && fieldId === 'created' && (0, $4cTDP.fg)('relay-migration-issue-history')) return {
        fieldType: 'jira',
        type: (0, $46dbc1f137614648$export$91de1ada4d2d3ca6),
        actor: actor,
        timestamp: timestamp
    };
    return {
        fieldType: (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $46dbc1f137614648$export$f567ac9d3526e5ce),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from.displayValue,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toValue: to.displayValue
    };
};
const $24675b39e1fc3320$export$5135eb3afa736a29 = ({ fields: { created: created, creator: creator } })=>({
        fieldType: 'jira',
        type: (0, $46dbc1f137614648$export$91de1ada4d2d3ca6),
        actor: $24675b39e1fc3320$var$transformRestActor(creator),
        timestamp: (0, $kQ82p.default)(created)
    });
const $24675b39e1fc3320$export$716425a07890b235 = (data, maxResults)=>({
        nextPageStartIndex: data.viewIssue.history.isLast ? 0 : data.viewIssue.history.startIndex + maxResults,
        isLastPage: data.viewIssue.history.isLast,
        history: data.viewIssue.history.nodes.map($24675b39e1fc3320$export$a32d3e40a269588f)
    });

});
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $46dbc1f137614648$var$HISTORY_GROUPED_ITEMS_CATEGORY = 'HISTORY';
const $46dbc1f137614648$export$ed83fff9d5b2ca44 = 'REDACTION_GROUPED_HISTORY_ITEM';
const $46dbc1f137614648$export$f1970b3f16b29de5 = 'ASSIGNEE_CHANGED';
const $46dbc1f137614648$export$7566709b8f78aeb1 = 'STATUS_CHANGED';
const $46dbc1f137614648$export$53e9822dbffbb9bc = 'COMMENT_CHANGED';
const $46dbc1f137614648$export$5fd7b626c41a75e3 = 'ARCHIVED_CHANGED';
const $46dbc1f137614648$export$107cfebb0511df9e = 'ATTACHMENT_CHANGED';
const $46dbc1f137614648$export$e0672bc3e33c4c82 = 'PRIORITY_CHANGED';
const $46dbc1f137614648$export$e5cb2c6d5fff1f58 = 'FLAG_CHANGED';
const $46dbc1f137614648$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
const $46dbc1f137614648$export$b45ef25f7a696e98 = 'NUMERIC_FIELD_CHANGED';
const $46dbc1f137614648$export$771d231cdd66c0e2 = 'RICH_TEXT_FIELD_CHANGED';
const $46dbc1f137614648$export$91de1ada4d2d3ca6 = 'ISSUE_CREATED';
const $46dbc1f137614648$export$33b21ab9c6fec8d0 = 'WORK_LOGGED';
const $46dbc1f137614648$export$37c97aab53f01e4c = 'TIME_CHANGED';
const $46dbc1f137614648$export$edaa98b0c4bb1ef3 = 'PARENT_ISSUE_CHANGED';
const $46dbc1f137614648$export$ccf54e923acb91b2 = 'DATE_ISSUE_CHANGED';
const $46dbc1f137614648$export$69a77f5e7c42a227 = 'RESPONDERS_CHANGED';
const $46dbc1f137614648$export$bf9ba14f4fe0e36a = 'AFFECTED_SERVICES_CHANGED';
const $46dbc1f137614648$export$33f8a9cb608132ba = 'Responders';
const $46dbc1f137614648$export$5e56d79dfe9be3d = 'Affected services';
const $46dbc1f137614648$export$a3171a3a7d9e1e5b = 'team';
const $46dbc1f137614648$export$1187c3553ecd80a1 = 'user';
const $46dbc1f137614648$export$844d56dab10d6cfb = 'DATA_CLASSIFICATION_CHANGED';
const $46dbc1f137614648$export$53027079dd8d1476 = 'DATA_REDACTED';
const $46dbc1f137614648$export$ac51718b2bcd56c9 = 'DATA_REDACTION_RESTORED';
const $46dbc1f137614648$export$8648a9c7bbb05a59 = 'ATTACHMENT_UPLOADED';
const $46dbc1f137614648$export$4427798ee4002a4d = 'ATTACHMENT_DELETED';
const $46dbc1f137614648$export$75936e876282682b = 'FLAG_ADDED';
const $46dbc1f137614648$export$cc84d15d1f34510d = 'FLAG_REMOVED';



parcelRegister("4TOFo", function(module, exports) {
$parcel$export(module.exports, "groupHistoryItems", () => $396e3af5eb4ca2e4$export$5502f38a1909b15b);

var $aXKmr = parcelRequire("aXKmr");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

const $396e3af5eb4ca2e4$var$HISTORY_GROUPED_ITEMS_CATEGORY = 'HISTORY';
const $396e3af5eb4ca2e4$var$TIME_BATCH = 5;
const $396e3af5eb4ca2e4$var$isWithinTimeBatch = (item, lastItem)=>Math.abs(lastItem.timestamp.getTime() - item.timestamp.getTime()) / 60000 <= $396e3af5eb4ca2e4$var$TIME_BATCH;
const $396e3af5eb4ca2e4$var$isDescendingOrder = (firstItem, lastItem)=>firstItem.timestamp > lastItem.timestamp;
const $396e3af5eb4ca2e4$export$5502f38a1909b15b = (items)=>{
    if (!(0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return items;
    if (!items.length) return [];
    const itemsMap = new Map();
    const orderIsDescending = $396e3af5eb4ca2e4$var$isDescendingOrder(items[0], items[items.length - 1]);
    items.forEach((item)=>{
        if (item.type === (0, $46dbc1f137614648$export$91de1ada4d2d3ca6)) {
            // we don't want to group this entry, so setting the item's id (not actor's id) as a key to disable potential further grouping
            itemsMap.set((0, $aXKmr.v4)(), item);
            return;
        }
        const actor = item.actor;
        // Group redacted items separately, follow same grouping logic
        if (item.type === (0, $46dbc1f137614648$export$53027079dd8d1476) && (0, $4cTDP.fg)('enable_redaction_support_in_jira_issue_view')) {
            // appending item type to differentiate redaction actors from other history items
            const currentItem = itemsMap.get(actor?.accountId + item.type);
            if (!currentItem) {
                if (actor?.accountId) itemsMap.set(actor.accountId + (0, $46dbc1f137614648$export$53027079dd8d1476), item);
            } else {
                const isAlreadyGrouped = currentItem.type === (0, $46dbc1f137614648$export$ed83fff9d5b2ca44);
                if ($396e3af5eb4ca2e4$var$isWithinTimeBatch(item, currentItem)) {
                    if (isAlreadyGrouped) currentItem.items.push(item);
                    else itemsMap.set(actor?.accountId + (0, $46dbc1f137614648$export$53027079dd8d1476), {
                        type: (0, $46dbc1f137614648$export$ed83fff9d5b2ca44),
                        timestamp: currentItem.timestamp,
                        actor: currentItem.actor,
                        items: [
                            currentItem,
                            item
                        ]
                    });
                } else {
                    // don't need to be grouped, so setting the random id as a key to disable potential further grouping
                    itemsMap.set((0, $aXKmr.v4)(), currentItem);
                    itemsMap.set(actor?.accountId + (0, $46dbc1f137614648$export$53027079dd8d1476), item);
                }
            }
            return;
        }
        const currentItem = itemsMap.get(actor?.accountId);
        if (!currentItem) {
            if (actor?.accountId) itemsMap.set(actor.accountId, item);
        } else {
            const isAlreadyGrouped = currentItem.type === $396e3af5eb4ca2e4$var$HISTORY_GROUPED_ITEMS_CATEGORY;
            if ($396e3af5eb4ca2e4$var$isWithinTimeBatch(item, currentItem)) {
                if (isAlreadyGrouped) currentItem.items.push(item);
                else itemsMap.set(actor?.accountId, {
                    type: $396e3af5eb4ca2e4$var$HISTORY_GROUPED_ITEMS_CATEGORY,
                    timestamp: currentItem.timestamp,
                    actor: currentItem.actor,
                    items: [
                        currentItem,
                        item
                    ]
                });
            } else {
                // don't need to be grouped, so setting the random id as a key to disable potential further grouping
                itemsMap.set((0, $aXKmr.v4)(), currentItem);
                itemsMap.set(actor?.accountId, item);
            }
        }
    });
    const sortedByTimeItems = Array.from(itemsMap.values()).sort((a, b)=>{
        if (orderIsDescending) return b.timestamp.getTime() - a.timestamp.getTime();
        return a.timestamp.getTime() - b.timestamp.getTime();
    });
    return sortedByTimeItems;
};

});


parcelRegister("df3FJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcd49b396e7881e1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cxKOj = parcelRequire("cxKOj");

var $dTocu = parcelRequire("dTocu");


var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $h47gY = parcelRequire("h47gY");

var $bmoS1 = parcelRequire("bmoS1");

var $eSnSE = parcelRequire("eSnSE");

var $4W9nT = parcelRequire("4W9nT");

var $9DsBy = parcelRequire("9DsBy");

var $jJZoL = parcelRequire("jJZoL");
const $bcd49b396e7881e1$var$HISTORY_GROUPED_ITEMS_CATEGORY = 'HISTORY';
// Error boundary wrapper for individual history items
const $bcd49b396e7881e1$var$HistoryItemWithErrorBoundary = ({ historyItem: historyItem })=>{
    const handleError = (location, error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-history.history-item-render-error', 'Failed to render individual history item', {
            error: error?.message,
            errorStack: error?.stack,
            componentStack: location,
            historyItemType: historyItem?.type
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        packageName: "issue-history",
        onError: handleError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9DsBy.default), {
        historyItem: historyItem
    }));
};
const $bcd49b396e7881e1$export$1b027679229955ad = ({ formatMessage: formatMessage, isLoadingMore: isLoadingMore, onLoadMore: onLoadMore, sortOrder: sortOrder })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const prevIsLoadingMore = (0, $eJOHy.useRef)(isLoadingMore);
    (0, $eJOHy.useEffect)(()=>{
        prevIsLoadingMore.current = isLoadingMore;
    }, [
        isLoadingMore
    ]);
    const onLoadMoreButtonClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'loadMoreButtonClicked', {
            loadMoreButtonTypeClicked: sortOrder === (0, $b3f7436b1db296f5$export$eda5fe8da1abb04c) ? 'LOAD_OLDER_BUTTON' : 'LOAD_NEWER_BUTTON'
        });
        onLoadMore();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4W9nT.default), {
        shouldFitContainer: true,
        isDisabled: isLoadingMore,
        isLoading: isLoadingMore,
        onClick: onLoadMoreButtonClick
    }, formatMessage((0, $jJZoL.default).loadMore));
};
const $bcd49b396e7881e1$var$HistoryItems = ({ history: history, isLoadingMore: isLoadingMore, onLoadMore: onLoadMore, hasMore: hasMore, sortOrder: sortOrder, GroupedActivityEntryComponent: GroupedActivityEntry })=>{
    const intl = (0, $dTocu.useIntlV2)();
    const shouldUseRelayIssueHistory = (0, $bmoS1.useShouldUseRelayIssueHistory)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "historyItems",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a)
    }, history.map((historyItem, index)=>{
        const isGroupedActivityEntryEnrolledInIssueViewActivityTimelineExperiment = // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) && historyItem?.type === $bcd49b396e7881e1$var$HISTORY_GROUPED_ITEMS_CATEGORY && GroupedActivityEntry;
        if (isGroupedActivityEntryEnrolledInIssueViewActivityTimelineExperiment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(GroupedActivityEntry, {
            key: index,
            item: historyItem
        });
        if ((0, $cxKOj.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9DsBy.default), {
            historyItem: historyItem
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $bcd49b396e7881e1$var$horizontalDividerStyles
        }));
        return shouldUseRelayIssueHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcd49b396e7881e1$var$HistoryItemWithErrorBoundary, {
            key: index,
            historyItem: historyItem
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9DsBy.default), {
            key: index,
            historyItem: historyItem
        });
    }), hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "issue-history.ui.history-items.load-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcd49b396e7881e1$export$1b027679229955ad, {
        formatMessage: intl.formatMessage,
        isLoadingMore: isLoadingMore,
        onLoadMore: onLoadMore,
        sortOrder: sortOrder
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null));
};
const $bcd49b396e7881e1$var$horizontalDividerStyles = (0, $1DXK0.xcss)({
    height: '1px',
    width: '100%',
    backgroundColor: 'color.background.neutral',
    marginTop: 'space.200'
});
var $bcd49b396e7881e1$export$2e2bcd8739ae039 = $bcd49b396e7881e1$var$HistoryItems;

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("4W9nT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6247f86937eae34$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $7ep4S = parcelRequire("7ep4S");
// Mimics the new `isLoading` prop in @atlaskit/button@7.x. This component can
// be deleted when we upgrade to the latest version of @atlaskit/button.
const $c6247f86937eae34$var$LoadingButton = (props)=>{
    const { children: children, isDisabled: isDisabled, isLoading: isLoading, onClick: onClick, shouldFitContainer: shouldFitContainer } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClick,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
        iconAfter: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        }) : null,
        shouldFitContainer: shouldFitContainer
    }, !isLoading ? children : null);
};
var $c6247f86937eae34$export$2e2bcd8739ae039 = $c6247f86937eae34$var$LoadingButton;

});

parcelRegister("jJZoL", function(module, exports) {
$parcel$export(module.exports, "default", () => $91d7e6d31da93034$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $91d7e6d31da93034$var$messages = (0, $7qGN1.defineMessages)({
    loadMore: {
        "id": "issue-history.history-items.load-more",
        "defaultMessage": "Load more"
    }
});
var $91d7e6d31da93034$export$2e2bcd8739ae039 = $91d7e6d31da93034$var$messages;

});



parcelRegister("20JeF", function(module, exports) {
$parcel$export(module.exports, "default", () => $6646066a4051f7b6$export$2e2bcd8739ae039);

var $lVkn3 = parcelRequire("lVkn3");

var $a3otq = parcelRequire("a3otq");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $hJRKH = parcelRequire("hJRKH");

var $bjCt4 = parcelRequire("bjCt4");

var $2imLM = parcelRequire("2imLM");

var $cHtIB = parcelRequire("cHtIB");

var $k5dCK = parcelRequire("k5dCK");

var $dyOHn = parcelRequire("dyOHn");

var $88uGO = parcelRequire("88uGO");

var $4TOFo = parcelRequire("4TOFo");

var $d3a6V = parcelRequire("d3a6V");

var $df3FJ = parcelRequire("df3FJ");
const $6646066a4051f7b6$var$HISTORY_ITEMS_TO_LOAD = 100;
const $6646066a4051f7b6$var$DEFAULT_QUERY_PAGINATION_CURSORS = {
    first: $6646066a4051f7b6$var$HISTORY_ITEMS_TO_LOAD,
    after: undefined,
    last: undefined,
    before: undefined
};
// eslint-disable-next-line jira/relay/no-query
const $6646066a4051f7b6$var$IssueHistoryQuery = (0, $a3otq.default);
const $6646066a4051f7b6$var$IssueHistoryRelay = (props)=>{
    const { issueKey: issueKey, sortOrder: sortOrder, GroupedActivityEntryComponent: GroupedActivityEntryComponent, onHistoryFetchAnalytics: onHistoryFetchAnalytics } = props;
    const cloudId = (0, $cHtIB.useCloudId)();
    // Convert sort order to GraphQL orderBy parameter
    const orderBy = sortOrder === 'OLDEST_FIRST' ? 'created' : '-created';
    const timeTrackingConfig = (0, $dyOHn.useSelector)((0, $k5dCK.timeTrackingConfigurationSelector));
    const queryData = (0, $j4oe4.useLazyLoadQuery)($6646066a4051f7b6$var$IssueHistoryQuery, {
        issueKey: issueKey,
        cloudId: cloudId,
        orderBy: orderBy,
        first: $6646066a4051f7b6$var$DEFAULT_QUERY_PAGINATION_CURSORS.first,
        after: $6646066a4051f7b6$var$DEFAULT_QUERY_PAGINATION_CURSORS.after,
        last: $6646066a4051f7b6$var$DEFAULT_QUERY_PAGINATION_CURSORS.last,
        before: $6646066a4051f7b6$var$DEFAULT_QUERY_PAGINATION_CURSORS.before
    }, {
        fetchPolicy: 'store-and-network'
    });
    const { data: data, hasNext: hasNext, isLoadingNext: isLoadingNext, loadNext: loadNext } = (0, $j4oe4.usePaginationFragment)((0, $lVkn3.default), queryData?.jira?.issueByKey);
    // Track query variables to detect genuine query executions
    const executionKey = `${issueKey}-${cloudId}-${orderBy}`;
    // Track the executionKey we've already fired analytics for to prevent duplicates
    const consumedExecutionKeyRef = (0, $eJOHy.useRef)(null);
    // Analytics for FETCH_PAGE - fire once per query execution when data is available
    (0, $eJOHy.useEffect)(()=>{
        if (consumedExecutionKeyRef.current !== executionKey && data?.history?.edges && Array.isArray(data.history.edges) && data.history.edges.length > 0) {
            onHistoryFetchAnalytics();
            consumedExecutionKeyRef.current = executionKey;
        }
    }, [
        executionKey,
        data?.history?.edges,
        onHistoryFetchAnalytics
    ]);
    const handleLoadMoreNext = (0, $eJOHy.useCallback)(()=>{
        if (hasNext && !isLoadingNext) loadNext($6646066a4051f7b6$var$HISTORY_ITEMS_TO_LOAD, {
            onComplete: (error)=>{
                if (!error) onHistoryFetchAnalytics();
            }
        });
    }, [
        hasNext,
        isLoadingNext,
        loadNext,
        onHistoryFetchAnalytics
    ]);
    if (!data?.history?.edges || Array.isArray(data.history.edges) && data.history.edges.length === 0) return null;
    // Adapter function to convert Relay data to Gira format for reuse of existing transformation
    const adaptRelayToGiraFormat = (relayItem)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const adaptFieldValue = (fieldValue)=>{
            if (!fieldValue) return null;
            const adapted = {
                ...fieldValue
            };
            if (fieldValue.worklog) adapted.worklog = {
                ...fieldValue.worklog,
                // comment:
                // 	fieldValue.worklog.workDescription?.adfValue?.convertedPlainText?.plainText || '',
                timeSpent: (0, $bjCt4.default)(timeTrackingConfig.daysPerWeek, timeTrackingConfig.hoursPerDay)(fieldValue.worklog.timeSpent?.timeInSeconds ?? 0)
            };
            return adapted;
        };
        return {
            fieldId: relayItem.fieldId ?? '',
            fieldType: relayItem.fieldType === 'jira' || relayItem.fieldType === 'custom' ? relayItem.fieldType : 'custom',
            fieldSchema: relayItem.fieldSchema ? {
                ...relayItem.fieldSchema,
                type: relayItem.fieldSchema.type ?? ''
            } : undefined,
            timestamp: relayItem.timestamp ?? 0,
            // Convert null/undefined to 0
            actor: relayItem.actor ? {
                accountId: relayItem.actor.accountId ?? '',
                avatarUrls: {
                    large: relayItem.actor.picture ?? ''
                },
                displayName: relayItem.actor.name ?? ''
            } : undefined,
            fieldDisplayName: relayItem.fieldDisplayName ?? '',
            isDueToRedaction: relayItem.isDueToRedaction ?? false,
            isDueToRedactionRestore: relayItem.isDueToRedactionRestore ?? false,
            from: adaptFieldValue(relayItem.from),
            to: adaptFieldValue(relayItem.to),
            timeTrackingConfig: timeTrackingConfig
        };
    };
    // Transform Relay data to HistoryItem[] format using existing transformation logic
    const rawHistoryItems = data.history.edges.map((edge)=>edge.node);
    const adaptedItems = rawHistoryItems.map(adaptRelayToGiraFormat);
    const transformedItems = adaptedItems.map((0, $88uGO.transformChangelogItem));
    const groupedItems = (0, $4TOFo.groupHistoryItems)(transformedItems);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d3a6V.FeedContainer), {
        "data-testid": "issue-history.ui.feed-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $df3FJ.default), {
        history: groupedItems,
        hasMore: hasNext,
        isLoadingMore: isLoadingNext,
        onLoadMore: handleLoadMoreNext,
        sortOrder: sortOrder,
        GroupedActivityEntryComponent: GroupedActivityEntryComponent
    }));
};
function $6646066a4051f7b6$var$IssueHistory(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "issue-history-placeholder",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d3a6V.FeedContainer), {
            "data-testid": "issue-history.ui.feed-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hJRKH.default), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6646066a4051f7b6$var$IssueHistoryRelay, props));
}
var $6646066a4051f7b6$export$2e2bcd8739ae039 = $6646066a4051f7b6$var$IssueHistory;

});
parcelRegister("lVkn3", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ed916c61b1439d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<de4b73143d686e27a49b9b35a206a575>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $gNVFA = parcelRequire("gNVFA");
const $5ed916c61b1439d3$var$node = function() {
    var v0 = [
        "history"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "kind": "ScalarField",
        "name": "formattedValue"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayValue"
    }, v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = {
        "kind": "ScalarField",
        "name": "avatarUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "categoryId"
                },
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "type": "JiraHistoryStatusFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "concreteType": "JiraWorklog",
                    "kind": "LinkedField",
                    "name": "worklog",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "worklogId"
                        },
                        {
                            "concreteType": "JiraEstimate",
                            "kind": "LinkedField",
                            "name": "timeSpent",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "timeInSeconds"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraRichText",
                            "kind": "LinkedField",
                            "name": "workDescription",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraADF",
                                    "kind": "LinkedField",
                                    "name": "adfValue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "json"
                                        },
                                        {
                                            "concreteType": "JiraAdfToConvertedPlainText",
                                            "kind": "LinkedField",
                                            "name": "convertedPlainText",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "plainText"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraHistoryWorkLogFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "type": "JiraHistoryAssigneeFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "absoluteIconUrl"
                }
            ],
            "type": "JiraHistoryPriorityFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "concreteType": "JiraHistoryResponder",
                    "kind": "LinkedField",
                    "name": "responders",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ari"
                        },
                        v7 /*: any*/ ,
                        v2 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "JiraHistoryRespondersFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "type": "JiraHistoryGenericFieldValue"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "orderBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $gNVFA.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "IssueHistoryFragment",
        "selections": [
            {
                "alias": "history",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "orderBy",
                        "variableName": "orderBy"
                    }
                ],
                "concreteType": "JiraIssueHistoryConnection",
                "kind": "LinkedField",
                "name": "__IssueHistory_history_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueHistoryEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraHistoryActivityFeedItem",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "i18nDescription"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "fieldDisplayName"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "fieldId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "fieldType"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "timestamp"
                                    },
                                    {
                                        "concreteType": "JiraHistoryFieldSchema",
                                        "kind": "LinkedField",
                                        "name": "fieldSchema",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "customFieldType"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDueToRedaction"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDueToRedactionRestore"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "from",
                                        "plural": false,
                                        "selections": v8 /*: any*/ 
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "to",
                                        "plural": false,
                                        "selections": v8 /*: any*/ 
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "actor",
                                        "plural": false,
                                        "selections": [
                                            v7 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "accountId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "picture"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            }
                        ]
                    }
                ]
            },
            v1 /*: any*/ 
        ],
        "type": "JiraIssue"
    };
}();
$5ed916c61b1439d3$var$node.hash = "ee576f8f8aa6ff147c359258d1d2457b";
var $5ed916c61b1439d3$export$2e2bcd8739ae039 = $5ed916c61b1439d3$var$node;

});
parcelRegister("gNVFA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b180666d01f5ff61$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6770f915ad5824ba08605cd52fdc2a1>>
 * @relayHash 73bfbcdd7827d0d9020839eddbccc4fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe06f62997e020691a5c30e3df796af933531d6afecff4a8cbd40792e66b36d2
const $b180666d01f5ff61$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "orderBy",
            "variableName": "orderBy"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "ScalarField",
        "name": "formattedValue"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayValue"
    }, v13 = {
        "kind": "ScalarField",
        "name": "value"
    }, v14 = {
        "kind": "ScalarField",
        "name": "avatarUrl"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = [
        v7 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v11 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "categoryId"
                },
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "type": "JiraHistoryStatusFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                {
                    "concreteType": "JiraWorklog",
                    "kind": "LinkedField",
                    "name": "worklog",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "worklogId"
                        },
                        {
                            "concreteType": "JiraEstimate",
                            "kind": "LinkedField",
                            "name": "timeSpent",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "timeInSeconds"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraRichText",
                            "kind": "LinkedField",
                            "name": "workDescription",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraADF",
                                    "kind": "LinkedField",
                                    "name": "adfValue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "json"
                                        },
                                        {
                                            "concreteType": "JiraAdfToConvertedPlainText",
                                            "kind": "LinkedField",
                                            "name": "convertedPlainText",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "plainText"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraHistoryWorkLogFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v12 /*: any*/ 
            ],
            "type": "JiraHistoryAssigneeFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v13 /*: any*/ ,
                v12 /*: any*/ ,
                v11 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "absoluteIconUrl"
                }
            ],
            "type": "JiraHistoryPriorityFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                {
                    "concreteType": "JiraHistoryResponder",
                    "kind": "LinkedField",
                    "name": "responders",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ari"
                        },
                        v15 /*: any*/ ,
                        v10 /*: any*/ ,
                        v14 /*: any*/ 
                    ]
                }
            ],
            "type": "JiraHistoryRespondersFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "type": "JiraHistoryGenericFieldValue"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueHistory_RefetchQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "IssueHistoryFragment"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "IssueHistory_RefetchQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraIssueHistoryConnection",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueHistoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraHistoryActivityFeedItem",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "i18nDescription"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldDisplayName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "timestamp"
                                                        },
                                                        {
                                                            "concreteType": "JiraHistoryFieldSchema",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSchema",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "customFieldType"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isDueToRedaction"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isDueToRedactionRestore"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "from",
                                                            "plural": false,
                                                            "selections": v16 /*: any*/ 
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": v16 /*: any*/ 
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "actor",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v9 /*: any*/ ,
                                    "filters": [
                                        "orderBy"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueHistory_history",
                                    "kind": "LinkedHandle",
                                    "name": "history"
                                }
                            ],
                            "type": "JiraIssue"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fe06f62997e020691a5c30e3df796af933531d6afecff4a8cbd40792e66b36d2",
            "metadata": {},
            "name": "IssueHistory_RefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b180666d01f5ff61$var$node.hash = "ee576f8f8aa6ff147c359258d1d2457b";
var $b180666d01f5ff61$export$2e2bcd8739ae039 = $b180666d01f5ff61$var$node;

});


parcelRegister("a3otq", function(module, exports) {
$parcel$export(module.exports, "default", () => $b99859e5297384d7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67921d675b5d807e7a4b27cb618ccf42>>
 * @relayHash 0545ddb77abd8407f2071acc8b78d28f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7d8e016e3df0914d15e46964255ad8e9852ea7c2db4943ee6b8afbfd6e86829
const $b99859e5297384d7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "orderBy",
            "variableName": "orderBy"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "formattedValue"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayValue"
    }, v14 = {
        "kind": "ScalarField",
        "name": "value"
    }, v15 = {
        "kind": "ScalarField",
        "name": "avatarUrl"
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = [
        v11 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "categoryId"
                },
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "type": "JiraHistoryStatusFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "concreteType": "JiraWorklog",
                    "kind": "LinkedField",
                    "name": "worklog",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "worklogId"
                        },
                        {
                            "concreteType": "JiraEstimate",
                            "kind": "LinkedField",
                            "name": "timeSpent",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "timeInSeconds"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraRichText",
                            "kind": "LinkedField",
                            "name": "workDescription",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraADF",
                                    "kind": "LinkedField",
                                    "name": "adfValue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "json"
                                        },
                                        {
                                            "concreteType": "JiraAdfToConvertedPlainText",
                                            "kind": "LinkedField",
                                            "name": "convertedPlainText",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "plainText"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraHistoryWorkLogFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v12 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "type": "JiraHistoryAssigneeFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v14 /*: any*/ ,
                v13 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "absoluteIconUrl"
                }
            ],
            "type": "JiraHistoryPriorityFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "concreteType": "JiraHistoryResponder",
                    "kind": "LinkedField",
                    "name": "responders",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ari"
                        },
                        v16 /*: any*/ ,
                        v10 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                }
            ],
            "type": "JiraHistoryRespondersFieldValue"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "type": "JiraHistoryGenericFieldValue"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueHistoryQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "IssueHistoryFragment"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.issueByKey"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "IssueHistoryQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraIssueHistoryConnection",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueHistoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraHistoryActivityFeedItem",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "i18nDescription"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldDisplayName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "timestamp"
                                                        },
                                                        {
                                                            "concreteType": "JiraHistoryFieldSchema",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSchema",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "customFieldType"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isDueToRedaction"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isDueToRedactionRestore"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "from",
                                                            "plural": false,
                                                            "selections": v17 /*: any*/ 
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": v17 /*: any*/ 
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "actor",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v8 /*: any*/ ,
                                    "filters": [
                                        "orderBy"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueHistory_history",
                                    "kind": "LinkedHandle",
                                    "name": "history"
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e7d8e016e3df0914d15e46964255ad8e9852ea7c2db4943ee6b8afbfd6e86829",
            "metadata": {},
            "name": "IssueHistoryQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b99859e5297384d7$var$node.hash = "909f36efa1b2ba088df4e2d00baf9607";
var $b99859e5297384d7$export$2e2bcd8739ae039 = $b99859e5297384d7$var$node;

});

parcelRegister("bjCt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b110ba771aff996$export$2e2bcd8739ae039);
const $1b110ba771aff996$var$MINUTES_PER_HOUR = 60;
const $1b110ba771aff996$var$SECONDS_PER_MINUTE = 60;
const $1b110ba771aff996$var$secondsToTimeString = (daysPerWeek, hoursPerDay)=>{
    const units = [
        {
            suffix: 'w',
            seconds: daysPerWeek * hoursPerDay * $1b110ba771aff996$var$MINUTES_PER_HOUR * $1b110ba771aff996$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'd',
            seconds: hoursPerDay * $1b110ba771aff996$var$MINUTES_PER_HOUR * $1b110ba771aff996$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'h',
            seconds: $1b110ba771aff996$var$MINUTES_PER_HOUR * $1b110ba771aff996$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'm',
            seconds: $1b110ba771aff996$var$SECONDS_PER_MINUTE
        }
    ];
    return (seconds)=>{
        const initial = {
            secondsRemaining: seconds,
            timeString: ''
        };
        const result = units.reduce((acc, unit)=>{
            // Skip this unit if it doesn't have a valid number of seconds
            if (unit.seconds <= 0) return acc;
            const numUnits = Math.floor(acc.secondsRemaining / unit.seconds);
            const updatedSecondsRemaining = numUnits >= 1 ? acc.secondsRemaining % unit.seconds : acc.secondsRemaining;
            const updatedTimeString = numUnits >= 1 ? `${acc.timeString} ${numUnits}${unit.suffix}` : acc.timeString;
            return {
                secondsRemaining: updatedSecondsRemaining,
                timeString: updatedTimeString
            };
        }, initial);
        return result.timeString.trim() || '0m';
    };
};
var $1b110ba771aff996$export$2e2bcd8739ae039 = $1b110ba771aff996$var$secondsToTimeString;

});

parcelRegister("k5dCK", function(module, exports) {
$parcel$export(module.exports, "timeTrackingConfigurationSelector", () => $c70c80d083f63f35$export$7736678592f9894f);
$parcel$export(module.exports, "timeTrackingSelector", () => $c70c80d083f63f35$export$9641adea2fb165a5);
$parcel$export(module.exports, "isNativeJiraTimeTrackingEnabledSelector", () => $c70c80d083f63f35$export$393ba36370acb359);
$parcel$export(module.exports, "canLogTimeSelector", () => $c70c80d083f63f35$export$7fce678c5492d390);
$parcel$export(module.exports, "worklogLoadingStageSelector", () => $c70c80d083f63f35$export$19e0b8b93bf29f24);
$parcel$export(module.exports, "addTimeTrackingValues", () => $c70c80d083f63f35$export$eed3f72f0e15c099);
$parcel$export(module.exports, "shouldDisplayRollUpDataControlSelector", () => $c70c80d083f63f35$export$d07adbd6fcb1649b);
$parcel$export(module.exports, "timeTrackingWithSubtasksOrChildrenRollupSelector", () => $c70c80d083f63f35$export$9c9932e056c0e818);
$parcel$export(module.exports, "openModalSelector", () => $c70c80d083f63f35$export$88c9b23c79900aaf);
$parcel$export(module.exports, "worklogRefSelector", () => $c70c80d083f63f35$export$27b40ffee9e38f86);
$parcel$export(module.exports, "refetchWorklogsListSelector", () => $c70c80d083f63f35$export$44d00bdf38bda886);
$parcel$export(module.exports, "modalIsSavingSelector", () => $c70c80d083f63f35$export$a98a586066aec6ec);
$parcel$export(module.exports, "worklogsSelector", () => $c70c80d083f63f35$export$daafdb692849423a);
$parcel$export(module.exports, "activeWorklogSelector", () => $c70c80d083f63f35$export$a59b316c5487070c);
$parcel$export(module.exports, "sortedWorklogsSelector", () => $c70c80d083f63f35$export$cac06797b22541fc);
$parcel$export(module.exports, "totalWorklogsSelector", () => $c70c80d083f63f35$export$53e31443c2badd6b);
$parcel$export(module.exports, "worklogsStartIndexSelector", () => $c70c80d083f63f35$export$4e75bc36a7a5dc79);
$parcel$export(module.exports, "relayBridgeFetchWorklogsSelector", () => $c70c80d083f63f35$export$b4b048dbc2325ff3);
$parcel$export(module.exports, "relayBridgeTargetWorklogIdSelector", () => $c70c80d083f63f35$export$90870973b4e2ba98);

var $ahm5r = parcelRequire("ahm5r");

var $lBtjB = parcelRequire("lBtjB");

var $auYul = parcelRequire("auYul");

var $8oOr4 = parcelRequire("8oOr4");

var $aRxHj = parcelRequire("aRxHj");

var $5SpFk = parcelRequire("5SpFk");

var $8mcrY = parcelRequire("8mcrY");

var $5EgB1 = parcelRequire("5EgB1");

var $6t0ps = parcelRequire("6t0ps");

var $6az7p = parcelRequire("6az7p");

var $GhTyR = parcelRequire("GhTyR");
const $c70c80d083f63f35$export$7736678592f9894f = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.jiraSettings?.timeTrackingConfiguration || {});
const $c70c80d083f63f35$export$9641adea2fb165a5 = (0, $6t0ps.fieldPersistedValueSelector)((0, $8oOr4.TIME_TRACKING));
const $c70c80d083f63f35$export$aafac6da48dc3724 = (0, $ahm5r.createSelector)($c70c80d083f63f35$export$7736678592f9894f, (timeTrackingConfiguration)=>timeTrackingConfiguration.isTimeTrackingEnabled);
const $c70c80d083f63f35$export$393ba36370acb359 = (0, $ahm5r.createSelector)($c70c80d083f63f35$export$aafac6da48dc3724, (0, $6t0ps.availableFieldIdsSelector), (isTimeTrackingEnabled, availableFields)=>isTimeTrackingEnabled && availableFields.includes((0, $8oOr4.TIME_TRACKING)));
const $c70c80d083f63f35$export$7fce678c5492d390 = (0, $ahm5r.createSelector)($c70c80d083f63f35$export$393ba36370acb359, (0, $GhTyR.permissionsSelector), (0, $5EgB1.isMobileSelector), (isNativeJiraTimeTrackingEnabled, permissions, isMobile)=>isNativeJiraTimeTrackingEnabled && permissions.canLogWork && !isMobile);
const $c70c80d083f63f35$var$worklogUiSelector = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.worklog);
const $c70c80d083f63f35$var$modalSelector = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$worklogUiSelector, (uiState)=>uiState.modal);
const $c70c80d083f63f35$export$19e0b8b93bf29f24 = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$worklogUiSelector, (uiState)=>uiState.loadingStage);
const $c70c80d083f63f35$export$587bf1a48c8fe6f7 = (0, $ahm5r.createSelector)((0, $6t0ps.fieldPersistedValueSelector)((0, $8oOr4.SUBTASKS)), (0, $6t0ps.fieldPersistedValueSelector)((0, $8oOr4.CHILDREN_ISSUES)), (0, $aRxHj.hierarchyLevelSelector), (subtasks, childIssues, newIssueHierarchyLevel)=>childIssues?.length && (0, $auYul.isBaseHierarchyLevel)(newIssueHierarchyLevel) ? childIssues : subtasks);
const $c70c80d083f63f35$export$b3764c489e8d015b = (0, $ahm5r.createSelector)((0, $5SpFk.persistedChildrenIssuesSelector), (0, $8mcrY.hasSubtasksSelector), (0, $aRxHj.hierarchyLevelSelector), (0, $6t0ps.childIssuesLimitUrlSelector), (childIssues, hasSubtasks, newIssueHierarchyLevel, getChildIssuesLimitUrl)=>hasSubtasks || (Boolean(childIssues?.length) || Boolean(getChildIssuesLimitUrl((0, $8oOr4.EPIC_ISSUES)) || getChildIssuesLimitUrl((0, $8oOr4.CHILDREN_ISSUES)))) && (0, $auYul.isBaseHierarchyLevel)(newIssueHierarchyLevel));
const $c70c80d083f63f35$export$eed3f72f0e15c099 = (originalValue, newValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(originalValue) || (0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(newValue) ? (originalValue || 0) + (newValue || 0) : originalValue ?? undefined;
// @ts-expect-error - TS7006 - Parameter 'fields' implicitly has an 'any' type.
const $c70c80d083f63f35$var$getSubFieldByName = (fields, fieldName)=>Array.isArray(fields) ? fields.find((field)=>field.key === fieldName)?.value : fields && fields[fieldName];
const $c70c80d083f63f35$export$135345e9de5fc488 = (0, $ahm5r.createSelector)($c70c80d083f63f35$export$587bf1a48c8fe6f7, (0, $6az7p.isClassicProjectSelector), (0, $6t0ps.childIssuesLimitUrlSelector), (childIssues, isClassicProject, getChildIssuesLimitUrl)=>{
    // Time tracking data is always available on classic subtasks even if the Time tracking field isn't configured
    if (isClassicProject) return true;
    if (getChildIssuesLimitUrl((0, $8oOr4.CHILDREN_ISSUES)) || getChildIssuesLimitUrl((0, $8oOr4.EPIC_ISSUES))) return true;
    if (!childIssues || childIssues.length === 0) return false;
    const childIssuesTimeTrackingValues = childIssues.map((subIssue)=>// if Time tracking fields aren't configured, undefined is returned
        $c70c80d083f63f35$var$getSubFieldByName(subIssue.fields, (0, $8oOr4.TIME_TRACKING))).filter(Boolean);
    return childIssuesTimeTrackingValues.length > 0;
});
const $c70c80d083f63f35$export$d07adbd6fcb1649b = (0, $ahm5r.createSelector)($c70c80d083f63f35$export$b3764c489e8d015b, $c70c80d083f63f35$export$135345e9de5fc488, (hasSubtasksOrBaseLevelChildren, doSubtasksOrBaseLevelChildrenHaveTimeTrackingConfigured)=>hasSubtasksOrBaseLevelChildren && doSubtasksOrBaseLevelChildrenHaveTimeTrackingConfigured);
const $c70c80d083f63f35$export$9c9932e056c0e818 = (0, $ahm5r.createSelector)($c70c80d083f63f35$export$9641adea2fb165a5, $c70c80d083f63f35$export$587bf1a48c8fe6f7, (currentIssueTimeTrackingData, subtasksOrChildIssues)=>(isRollingUpData)=>{
        // base case: we return just the current issue's time tracking data whenever the issue
        // has no subtasks or the respective UI option is unchecked
        if (!subtasksOrChildIssues || subtasksOrChildIssues.length === 0 || !isRollingUpData) return currentIssueTimeTrackingData || {};
        return subtasksOrChildIssues.map((subIssue)=>$c70c80d083f63f35$var$getSubFieldByName(subIssue.fields, (0, $8oOr4.TIME_TRACKING))).filter(Boolean).reduce((accumulator, current)=>({
                originalEstimateSeconds: $c70c80d083f63f35$export$eed3f72f0e15c099(accumulator.originalEstimateSeconds, current.originalEstimateSeconds),
                timeSpentSeconds: $c70c80d083f63f35$export$eed3f72f0e15c099(accumulator.timeSpentSeconds, current.timeSpentSeconds),
                remainingEstimateSeconds: $c70c80d083f63f35$export$eed3f72f0e15c099(accumulator.remainingEstimateSeconds, current.remainingEstimateSeconds)
            }), currentIssueTimeTrackingData || {});
    });
const $c70c80d083f63f35$export$88c9b23c79900aaf = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$modalSelector, (modalState)=>modalState.openModal);
const $c70c80d083f63f35$export$27b40ffee9e38f86 = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$modalSelector, (modalState)=>modalState.worklogRef);
const $c70c80d083f63f35$export$44d00bdf38bda886 = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$modalSelector, (modalState)=>modalState.onRefetchWorklogs);
const $c70c80d083f63f35$export$a98a586066aec6ec = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$modalSelector, (modalState)=>modalState.isSaving);
const $c70c80d083f63f35$var$activeWorklogIdSelector = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$modalSelector, (modalState)=>modalState.activeWorklogId);
const $c70c80d083f63f35$var$worklogEntitiesSelector = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.worklog);
const $c70c80d083f63f35$export$daafdb692849423a = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$worklogEntitiesSelector, (entitiesState)=>entitiesState.worklogs);
const $c70c80d083f63f35$export$a59b316c5487070c = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$activeWorklogIdSelector, $c70c80d083f63f35$export$daafdb692849423a, (activeWorklogId, worklogs)=>activeWorklogId && worklogs[activeWorklogId] || null);
const $c70c80d083f63f35$var$sortedWorklogIdsSelector = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$worklogEntitiesSelector, (entitiesState)=>entitiesState.sortedWorklogIds);
const $c70c80d083f63f35$export$cac06797b22541fc = (0, $ahm5r.createSelector)($c70c80d083f63f35$export$daafdb692849423a, $c70c80d083f63f35$var$sortedWorklogIdsSelector, (worklogs, sortedWorklogIds)=>{
    const worklogIds = Array.isArray(sortedWorklogIds) ? sortedWorklogIds : Object.keys(worklogs); // Since there's no sort, just return the worklogs
    return worklogIds.map((worklogId)=>worklogs[worklogId]);
});
const $c70c80d083f63f35$export$53e31443c2badd6b = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$worklogEntitiesSelector, (entities)=>entities.totalWorklogs);
const $c70c80d083f63f35$export$4e75bc36a7a5dc79 = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$worklogEntitiesSelector, (entities)=>entities.worklogsStartIndex || 0);
const $c70c80d083f63f35$export$b4b048dbc2325ff3 = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$worklogUiSelector, (uiState)=>uiState.relayBridge.fetchWorklogs);
const $c70c80d083f63f35$export$90870973b4e2ba98 = (0, $ahm5r.createSelector)($c70c80d083f63f35$var$worklogUiSelector, (uiState)=>uiState.relayBridge.targetWorklogId);

});
parcelRegister("aRxHj", function(module, exports) {
$parcel$export(module.exports, "supportedChildIssueTypesEntitiesSelector", () => $6d296485956e827c$export$1e8043fccfcba3b9);
$parcel$export(module.exports, "supportsChildCreationSelector", () => $6d296485956e827c$export$1af32b549149f3d9);
$parcel$export(module.exports, "parentLevelIssueTypeIdsSelector", () => $6d296485956e827c$export$be50776e2ae27cf6);
$parcel$export(module.exports, "parentLevelIssueTypeNamesSelector", () => $6d296485956e827c$export$57b3549670d3627b);
$parcel$export(module.exports, "sameLevelIssueTypesIdsSelector", () => $6d296485956e827c$export$a81bfe971074142b);
$parcel$export(module.exports, "hierarchyLevelSelector", () => $6d296485956e827c$export$4f7eb1d272a8015);
$parcel$export(module.exports, "isIssueBaseLevel", () => $6d296485956e827c$export$d9c73da87a448c4);

var $ahm5r = parcelRequire("ahm5r");

var $auYul = parcelRequire("auYul");

var $3mZMJ = parcelRequire("3mZMJ");

var $6t0ps = parcelRequire("6t0ps");

var $6az7p = parcelRequire("6az7p");

var $GhTyR = parcelRequire("GhTyR");

var $9B5nT = parcelRequire("9B5nT");
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6d296485956e827c$var$childLevelValueSelector = (0, $6t0ps.fieldPersistedValueSelector)((0, $3mZMJ.HIERARCHY_LEVEL_BELOW)) || null;
const $6d296485956e827c$var$isChildLevelSubtaskLevelSelector = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$childLevelValueSelector, (childLevelFieldValue)=>{
    if (!childLevelFieldValue) return false;
    return (0, $auYul.isSubtaskHierarchyLevel)(childLevelFieldValue.level);
});
const $6d296485956e827c$export$7a45e255c239753 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$childLevelValueSelector, (childLevelValue)=>childLevelValue && childLevelValue.issueTypes || []);
const $6d296485956e827c$export$1e8043fccfcba3b9 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), $6d296485956e827c$export$7a45e255c239753, (entities, supportedIssueTypes)=>{
    const allIssueTypes = entities.issueTypes;
    const supportedIssueTypeIds = supportedIssueTypes.map((issueType)=>issueType.id);
    return allIssueTypes.filter(// @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    (issueType)=>supportedIssueTypeIds.indexOf(issueType.id) !== -1);
});
const $6d296485956e827c$export$1af32b549149f3d9 = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), $6d296485956e827c$export$7a45e255c239753, $6d296485956e827c$var$isChildLevelSubtaskLevelSelector, (0, $6az7p.isSimplifiedProjectSelector), (permissions, supportedChildIssueTypes, isChildLevelSubtask, isSimplifiedProject)=>permissions.canCreateChildren && !!supportedChildIssueTypes.length && (isSimplifiedProject ? true : !isChildLevelSubtask));
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6d296485956e827c$var$parentLevelValueSelector = (0, $6t0ps.fieldPersistedValueSelector)((0, $3mZMJ.HIERARCHY_LEVEL_ABOVE)) || null;
const $6d296485956e827c$export$55a6507420d37093 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && (parentLevelValue.name || null));
const $6d296485956e827c$export$be50776e2ae27cf6 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypeIds.map(String) || []);
const $6d296485956e827c$export$57b3549670d3627b = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypes.map((type)=>type.name).filter((name)=>name) || []);
const $6d296485956e827c$var$hasParentLevelIssueTypeIdsSelector = (0, $ahm5r.createSelector)($6d296485956e827c$export$be50776e2ae27cf6, (parentLevelValue)=>parentLevelValue.length > 0);
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6d296485956e827c$var$sameLevelValueSelector = (0, $6t0ps.fieldPersistedValueSelector)((0, $3mZMJ.HIERARCHY_LEVEL_SAME_LEVEL)) || null;
const $6d296485956e827c$export$26996c7f0f08c0d8 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$sameLevelValueSelector, (sameLevelFieldValue)=>{
    if (!sameLevelFieldValue) return false;
    return (0, $auYul.isSubtaskHierarchyLevel)(sameLevelFieldValue.level);
});
const $6d296485956e827c$export$a81bfe971074142b = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? sameLevelFieldValue.issueTypeIds.map(String) : []);
const $6d296485956e827c$export$4f7eb1d272a8015 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? (0, $auYul.toHierarchyLevel)(sameLevelFieldValue.level) : null);
const $6d296485956e827c$export$d9c73da87a448c4 = (0, $ahm5r.createSelector)($6d296485956e827c$export$4f7eb1d272a8015, (level)=>{
    if (level == null) // Some product types (JSM, Core, ...) do not support hierarchies at all and will not return this field.
    // For these, all issues are considered to be "Base" level.
    return true;
    return (0, $auYul.isBaseHierarchyLevel)(level);
});
const $6d296485956e827c$export$5530450eb840ecb2 = (0, $ahm5r.createSelector)($6d296485956e827c$export$55a6507420d37093, (0, $9B5nT.canEditIssuesSelector), $6d296485956e827c$var$hasParentLevelIssueTypeIdsSelector, (parentLevelName, shouldShowAddParent, hasParentIssueTypeId)=>Boolean(parentLevelName) && shouldShowAddParent && hasParentIssueTypeId);

});
parcelRegister("6t0ps", function(module, exports) {
$parcel$export(module.exports, "fieldsSelector", () => $32ed8d2f1c11b95b$export$e1512647ca813bfa);
$parcel$export(module.exports, "fieldByCustomTypeSelector", () => $32ed8d2f1c11b95b$export$72dfc619a02c972c);
$parcel$export(module.exports, "fieldSelector", () => $32ed8d2f1c11b95b$export$4ee5e7baedf94214);
$parcel$export(module.exports, "issueTypeIdSelector", () => $32ed8d2f1c11b95b$export$22410768c09b3a82);
$parcel$export(module.exports, "issueTypeNameSelector", () => $32ed8d2f1c11b95b$export$477df8db13e4dac3);
$parcel$export(module.exports, "hasSubtasksSelector", () => $32ed8d2f1c11b95b$export$f363078714850fd9);
$parcel$export(module.exports, "hasSubtasksValuesSelector", () => $32ed8d2f1c11b95b$export$689f8f96c9d81e1b);
$parcel$export(module.exports, "hasPortfolioChildIssuesSelector", () => $32ed8d2f1c11b95b$export$724b8972771ff092);
$parcel$export(module.exports, "hasPortfolioChildIssueValuesSelector", () => $32ed8d2f1c11b95b$export$c6d2d4f8e243ac37);
$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $32ed8d2f1c11b95b$export$29f34d4d7c528e9c);
$parcel$export(module.exports, "hasChildrenIssueValuesSelector", () => $32ed8d2f1c11b95b$export$9034aaa32d45814b);
$parcel$export(module.exports, "childIssuesLimitUrlSelector", () => $32ed8d2f1c11b95b$export$762e13908aaafb2d);
$parcel$export(module.exports, "availableFieldIdsSelector", () => $32ed8d2f1c11b95b$export$641248fa887fb9ea);
$parcel$export(module.exports, "fieldSchemaConfigurationSelector", () => $32ed8d2f1c11b95b$export$3c65874760e68948);
$parcel$export(module.exports, "isFieldEditableSelector", () => $32ed8d2f1c11b95b$export$76ece3d8c4244af2);
$parcel$export(module.exports, "fieldNameSelector", () => $32ed8d2f1c11b95b$export$2d1abc174b8a710e);
$parcel$export(module.exports, "fieldMetaKeySelector", () => $32ed8d2f1c11b95b$export$351970d5fcbd0b29);
$parcel$export(module.exports, "fieldARISelector", () => $32ed8d2f1c11b95b$export$f6363cecfaa3a9b0);
$parcel$export(module.exports, "fieldAutoCompleteUrlSelector", () => $32ed8d2f1c11b95b$export$d27105f13ab27906);
$parcel$export(module.exports, "fieldAllowedValuesSelector", () => $32ed8d2f1c11b95b$export$351dc1c32c2771ea);
$parcel$export(module.exports, "isFieldRequiredSelector", () => $32ed8d2f1c11b95b$export$4c5f76e28914074);
$parcel$export(module.exports, "fieldTypeSelector", () => $32ed8d2f1c11b95b$export$9e2f15437ff59992);
$parcel$export(module.exports, "fieldPersistedValueSelector", () => $32ed8d2f1c11b95b$export$ae4660b0b7ebeee9);
$parcel$export(module.exports, "fieldPendingValueSelector", () => $32ed8d2f1c11b95b$export$2ae929653dce6648);
$parcel$export(module.exports, "fieldDefaultValueSelector", () => $32ed8d2f1c11b95b$export$e648d6f58e9627eb);
$parcel$export(module.exports, "fieldEditingValueSelector", () => $32ed8d2f1c11b95b$export$487becf51bedcd03);
$parcel$export(module.exports, "fieldEditingAdfValueSelector", () => $32ed8d2f1c11b95b$export$31406f841bca5b75);
$parcel$export(module.exports, "isFieldEditingSelector", () => $32ed8d2f1c11b95b$export$29e6b1cade110749);
$parcel$export(module.exports, "fieldEditSessionIdSelector", () => $32ed8d2f1c11b95b$export$c53ab145ef243c95);
$parcel$export(module.exports, "isFieldWaitingSelector", () => $32ed8d2f1c11b95b$export$30e972ebce44d9b8);
$parcel$export(module.exports, "fieldInvalidMessageSelector", () => $32ed8d2f1c11b95b$export$d323462f155519c3);
$parcel$export(module.exports, "fieldInvalidSelector", () => $32ed8d2f1c11b95b$export$e35f4d21d9739426);
$parcel$export(module.exports, "isRichTextFieldSelector", () => $32ed8d2f1c11b95b$export$120a4249e9b3c231);
$parcel$export(module.exports, "richTextFieldIdsSelector", () => $32ed8d2f1c11b95b$export$862745d3ab4003e5);
$parcel$export(module.exports, "isRichTextFieldEditingSelector", () => $32ed8d2f1c11b95b$export$df9b7004d8b93e46);
$parcel$export(module.exports, "isMultilineFieldSelector", () => $32ed8d2f1c11b95b$export$4d0b1fe809ae5e75);
$parcel$export(module.exports, "getEditingMultilineFieldIdsSelector", () => $32ed8d2f1c11b95b$export$2469330614f0dba9);
$parcel$export(module.exports, "hasSpecificLabelSelector", () => $32ed8d2f1c11b95b$export$c0c580109fd31ef2);

var $ahm5r = parcelRequire("ahm5r");

var $6kS6u = parcelRequire("6kS6u");

var $dvdsN = parcelRequire("dvdsN");

var $eSnSE = parcelRequire("eSnSE");


var $8oOr4 = parcelRequire("8oOr4");

var $3mZMJ = parcelRequire("3mZMJ");


var $5EgB1 = parcelRequire("5EgB1");

var $enPW4 = parcelRequire("enPW4");

var $ljwVo = parcelRequire("ljwVo");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32ed8d2f1c11b95b$var$STABLE_EMPTY_ARRAY = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32ed8d2f1c11b95b$var$STABLE_EMPTY_OBJECT = {};
const $32ed8d2f1c11b95b$export$e1512647ca813bfa = (state)=>state.fields || $32ed8d2f1c11b95b$var$STABLE_EMPTY_OBJECT;
const $32ed8d2f1c11b95b$var$getFieldByCustomType = (customType, fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(fields, (field)=>(field.schema && field.schema.custom) === customType);
const $32ed8d2f1c11b95b$export$46dde968006cd8d4 = (fieldId, fields)=>{
    let field = fields[fieldId];
    const customSystemFields = (0, $8oOr4.specialFields)();
    if (!field && Object.keys(customSystemFields).includes(fieldId)) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        // @ts-expect-error - TS2322 - Type 'Field | undefined' is not assignable to type 'Field'.
        field = $32ed8d2f1c11b95b$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $32ed8d2f1c11b95b$export$cb67eba45dd11f50 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>!!fields[fieldId]);
const $32ed8d2f1c11b95b$export$309344981947f228 = (fieldsState, fieldName)=>Array.isArray(fieldsState[fieldName]?.value) ? fieldsState[fieldName].value.length > 0 : fieldsState[fieldName]?.value != null;
const $32ed8d2f1c11b95b$export$72dfc619a02c972c = (customType)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>$32ed8d2f1c11b95b$var$getFieldByCustomType(customType, fields));
const $32ed8d2f1c11b95b$export$4ee5e7baedf94214 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>$32ed8d2f1c11b95b$export$46dde968006cd8d4(fieldId, fields));
const $32ed8d2f1c11b95b$var$issueTypeFieldSelector = $32ed8d2f1c11b95b$export$4ee5e7baedf94214((0, $8oOr4.ISSUE_TYPE));
const $32ed8d2f1c11b95b$export$22410768c09b3a82 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$var$issueTypeFieldSelector, (issueType)=>(issueType && issueType.value && issueType.value.id) ?? null);
const $32ed8d2f1c11b95b$export$477df8db13e4dac3 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$var$issueTypeFieldSelector, (issueType)=>(issueType && issueType.value && issueType.value.name) ?? null);
const $32ed8d2f1c11b95b$export$b8de62018cc85a18 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>$32ed8d2f1c11b95b$export$46dde968006cd8d4(fieldId, fields));
const $32ed8d2f1c11b95b$export$3c65f67962ca81cc = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $c78d361852e02509$export$a5fc282ab2bf9b89)));
const $32ed8d2f1c11b95b$export$f363078714850fd9 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes('subtasks'));
const $32ed8d2f1c11b95b$export$689f8f96c9d81e1b = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>$32ed8d2f1c11b95b$export$309344981947f228(fields, 'subtasks'));
const $32ed8d2f1c11b95b$export$724b8972771ff092 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $8oOr4.PORTFOLIO_CHILD_ISSUES)));
const $32ed8d2f1c11b95b$export$c6d2d4f8e243ac37 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>$32ed8d2f1c11b95b$export$309344981947f228(fields, (0, $8oOr4.PORTFOLIO_CHILD_ISSUES)));
const $32ed8d2f1c11b95b$export$29f34d4d7c528e9c = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $8oOr4.CHILDREN_ISSUES)));
const $32ed8d2f1c11b95b$export$9034aaa32d45814b = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>$32ed8d2f1c11b95b$export$309344981947f228(fields, (0, $8oOr4.CHILDREN_ISSUES)));
const $32ed8d2f1c11b95b$export$762e13908aaafb2d = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>{
    const getChildIssueUrlSelector = (fieldId)=>fields?.[fieldId]?.issueLimitUrl || '';
    return getChildIssueUrlSelector;
});
const $32ed8d2f1c11b95b$export$9ee3b3f5d4ad4423 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>Object.keys(fields).map((fieldKey)=>$32ed8d2f1c11b95b$export$46dde968006cd8d4(fieldKey, fields)).filter(Boolean));
const $32ed8d2f1c11b95b$export$641248fa887fb9ea = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>Object.keys(fields));
const $32ed8d2f1c11b95b$export$e50b5889a6b86caf = (field)=>field ? field.editable : false;
const $32ed8d2f1c11b95b$export$3c65874760e68948 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.configuration && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        field.schema.configuration.reduce((config, { key: key, value: value })=>({
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...config,
                [key]: value
            }), {}));
const $32ed8d2f1c11b95b$export$76ece3d8c4244af2 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>$32ed8d2f1c11b95b$export$e50b5889a6b86caf(field));
const $32ed8d2f1c11b95b$export$2d1abc174b8a710e = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>{
        if (field && field.title) return field.title;
        (0, $eSnSE.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
        return '';
    });
const $32ed8d2f1c11b95b$export$d20285fb6e3fb007 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$b8de62018cc85a18, (state, { fieldId: fieldId })=>fieldId, (field, fieldId)=>{
    if (field?.title) return field.title;
    (0, $eSnSE.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
    return '';
});
const $32ed8d2f1c11b95b$export$351970d5fcbd0b29 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.key);
const $32ed8d2f1c11b95b$export$f6363cecfaa3a9b0 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.ari : undefined);
const $32ed8d2f1c11b95b$export$d27105f13ab27906 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.autoCompleteUrl);
const $32ed8d2f1c11b95b$export$351dc1c32c2771ea = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.allowedValues : $32ed8d2f1c11b95b$var$STABLE_EMPTY_ARRAY);
const $32ed8d2f1c11b95b$export$4c5f76e28914074 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.required : false);
const $32ed8d2f1c11b95b$export$9e2f15437ff59992 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $dvdsN.getFieldType)(field));
const $32ed8d2f1c11b95b$export$ae4660b0b7ebeee9 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.value);
const $32ed8d2f1c11b95b$export$bf3f8fd2c145740 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$b8de62018cc85a18, (field)=>field?.value);
const $32ed8d2f1c11b95b$export$2ae929653dce6648 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $ljwVo.default)(field));
const $32ed8d2f1c11b95b$export$e648d6f58e9627eb = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field?.adfValue);
const $32ed8d2f1c11b95b$export$487becf51bedcd03 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $enPW4.default)(field));
const $32ed8d2f1c11b95b$export$31406f841bca5b75 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (field)=>field && (0, $enPW4.getEditingAdfValue)(field));
const $32ed8d2f1c11b95b$export$e69c8171ecd8fde2 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.renderedValue);
const $32ed8d2f1c11b95b$export$4e96991314eba25 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$b8de62018cc85a18, (field)=>field?.renderedValue);
const $32ed8d2f1c11b95b$export$18ec1d851ee244b3 = (field)=>field ? field.editingValue !== undefined : false;
const $32ed8d2f1c11b95b$export$29e6b1cade110749 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>$32ed8d2f1c11b95b$export$18ec1d851ee244b3(field));
const $32ed8d2f1c11b95b$export$c53ab145ef243c95 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>(field ? field.fieldEditSessionId : null) || '');
const $32ed8d2f1c11b95b$export$30e972ebce44d9b8 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.pendingValue !== undefined : false);
const $32ed8d2f1c11b95b$export$d323462f155519c3 = (fieldId, fallbackInvalidMessage)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && (field.isInvalid ? field.invalidMessage || fallbackInvalidMessage : null));
const $32ed8d2f1c11b95b$export$e35f4d21d9739426 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>Boolean(field && field.isInvalid));
const $32ed8d2f1c11b95b$export$448aaad27e620666 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.renderer);
const $32ed8d2f1c11b95b$export$94cc87cea4e06b09 = (fieldType)=>fieldType === (0, $3mZMJ.TEXT_AREA_CF_TYPE) || fieldType === (0, $8oOr4.ENVIRONMENT) || fieldType === (0, $8oOr4.DESCRIPTION);
const $32ed8d2f1c11b95b$export$120a4249e9b3c231 = (fieldId)=>(0, $ahm5r.createSelector)((0, $5EgB1.isServiceDeskSelector), $32ed8d2f1c11b95b$export$9e2f15437ff59992(fieldId), $32ed8d2f1c11b95b$export$448aaad27e620666(fieldId), (isServiceDesk, fieldType, fieldRenderer)=>{
        const isDescription = fieldId === (0, $8oOr4.DESCRIPTION);
        const isMultilineRichTextField = $32ed8d2f1c11b95b$export$94cc87cea4e06b09(fieldType) && fieldRenderer === (0, $57c87778b42e34da$export$89b8c5d86c10a68c);
        return isDescription || isMultilineRichTextField;
    });
const $32ed8d2f1c11b95b$export$862745d3ab4003e5 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$32ed8d2f1c11b95b$export$120a4249e9b3c231(fieldId)(state)));
const $32ed8d2f1c11b95b$export$df9b7004d8b93e46 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$862745d3ab4003e5, (state)=>state, (richTextFieldIds, state)=>richTextFieldIds.some((fieldId)=>$32ed8d2f1c11b95b$export$29e6b1cade110749(fieldId)(state)));
const $32ed8d2f1c11b95b$export$4d0b1fe809ae5e75 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$9e2f15437ff59992(fieldId), (fieldType)=>$32ed8d2f1c11b95b$export$94cc87cea4e06b09(fieldType));
const $32ed8d2f1c11b95b$export$3263c202444b0e0 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$32ed8d2f1c11b95b$export$4d0b1fe809ae5e75(fieldId)(state)));
const $32ed8d2f1c11b95b$export$2469330614f0dba9 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$3263c202444b0e0, (state)=>state, (multilineFieldsIds, state)=>multilineFieldsIds.filter((fieldId)=>$32ed8d2f1c11b95b$export$29e6b1cade110749(fieldId)(state)));
const $32ed8d2f1c11b95b$export$a2fc0905011957cb = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214((0, $8oOr4.FIX_VERSIONS)), $32ed8d2f1c11b95b$export$4ee5e7baedf94214((0, $8oOr4.AFFECTS_VERSIONS)), (fixVersions, affectsVersions)=>{
    const ids = [];
    if (fixVersions) ids.push(fixVersions.key);
    if (affectsVersions) ids.push(affectsVersions.key);
    return ids;
});
const $32ed8d2f1c11b95b$export$c0c580109fd31ef2 = (labelValue)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214((0, $8oOr4.LABELS)), (field)=>{
        if (!field || !field.value || !Array.isArray(field.value)) return false;
        return field.value.includes(labelValue);
    });

});
const $57c87778b42e34da$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $57c87778b42e34da$export$a4a240cb4053b29f = 'jira-text-renderer';
const $57c87778b42e34da$export$840ed33fa94f7693 = 'frother-control-renderer';

const $c78d361852e02509$export$e18419056f3d184a = 'assignee';
const $c78d361852e02509$export$45cafdfd629c3ca1 = 'reporter';
const $c78d361852e02509$export$d5bc879e3b748593 = 'description';
const $c78d361852e02509$export$a68dbc90211df1a8 = 'fixVersions';
const $c78d361852e02509$export$93605f2a09aa8d26 = 'labels';
const $c78d361852e02509$export$4420b7468f889692 = 'status';
const $c78d361852e02509$export$e7cf1830fe735d1f = 'summary';
const $c78d361852e02509$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $c78d361852e02509$export$3fb78a14b7a56ff9 = 'timeestimate';
const $c78d361852e02509$export$a5fc282ab2bf9b89 = 'issuelinks';
const $c78d361852e02509$export$b52547457d714bc0 = 'epic-issues';
const $c78d361852e02509$export$3cca6e37a5823d5a = 'children-issues';
const $c78d361852e02509$export$98a935eb30de54ab = 'components';
const $c78d361852e02509$export$f7a17147527dd688 = 'flag';

parcelRegister("enPW4", function(module, exports) {
$parcel$export(module.exports, "default", () => $f35e2fdfbb3de59e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getEditingAdfValue", () => $f35e2fdfbb3de59e$export$a799cf637c5b7727);

var $ljwVo = parcelRequire("ljwVo");
/**
 * Returns the first available value for a given field.
 * editingValue => pendingValue => value
 */ const $f35e2fdfbb3de59e$var$getEditingValue = (field)=>typeof field.editingValue !== 'undefined' ? field.editingValue : (0, $ljwVo.default)(field);
var $f35e2fdfbb3de59e$export$2e2bcd8739ae039 = $f35e2fdfbb3de59e$var$getEditingValue;
const $f35e2fdfbb3de59e$export$a799cf637c5b7727 = (field)=>field.editingValue || (0, $ljwVo.getPendingAdfValue)(field);

});
parcelRegister("ljwVo", function(module, exports) {
$parcel$export(module.exports, "default", () => $e909d5c8ae6a695a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getPendingAdfValue", () => $e909d5c8ae6a695a$export$5012210a9f91b010);
/**
 * Returns the first available value for a given field, excluding editingValue
 * pendingValue => value
 */ const $e909d5c8ae6a695a$var$getPendingValue = (field)=>typeof field.pendingValue !== 'undefined' ? field.pendingValue : field.value;
var $e909d5c8ae6a695a$export$2e2bcd8739ae039 = $e909d5c8ae6a695a$var$getPendingValue;
const $e909d5c8ae6a695a$export$5012210a9f91b010 = (field)=>field.pendingValue || field.adfValue || field.value;

});



parcelRegister("6az7p", function(module, exports) {
$parcel$export(module.exports, "entitiesSelector", () => $0a42648be66bacce$export$ccebe5cc5854d0fa);
$parcel$export(module.exports, "projectSelector", () => $0a42648be66bacce$export$852a6c34ff1a2e77);
$parcel$export(module.exports, "uiSelector", () => $0a42648be66bacce$export$185c0864c82372e3);
$parcel$export(module.exports, "entitiesIssueSelector", () => $0a42648be66bacce$export$fa3ac1f794979805);
$parcel$export(module.exports, "entitiesRefreshedOnSelector", () => $0a42648be66bacce$export$c4ebdc93969b82cc);
$parcel$export(module.exports, "flagsSelector", () => $0a42648be66bacce$export$40cfdc5e96db7759);
$parcel$export(module.exports, "projectIdSelector", () => $0a42648be66bacce$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectIdsSelector", () => $0a42648be66bacce$export$9edb3f63d1bd8546);
$parcel$export(module.exports, "projectTypeSelector", () => $0a42648be66bacce$export$69316f88206ca90b);
$parcel$export(module.exports, "isSimplifiedProjectSelector", () => $0a42648be66bacce$export$d94d544d4b2e1310);
$parcel$export(module.exports, "loggedInUserDetailsSelector", () => $0a42648be66bacce$export$b5a68452fc64275d);
$parcel$export(module.exports, "loggedInUserAvatarUrlSelector", () => $0a42648be66bacce$export$e0efa9c12379be7a);
$parcel$export(module.exports, "loggedInUserDisplayNameSelector", () => $0a42648be66bacce$export$4f56a07246719eb0);
$parcel$export(module.exports, "parentIssueEntitySelector", () => $0a42648be66bacce$export$e10c57d263d23c49);
$parcel$export(module.exports, "loggedInUserTimeZoneSelector", () => $0a42648be66bacce$export$ac6f9fd801c94fff);
$parcel$export(module.exports, "idSelector", () => $0a42648be66bacce$export$66c501bed2fcd648);
$parcel$export(module.exports, "isClassicProjectSelector", () => $0a42648be66bacce$export$45347d9f8a67561b);
$parcel$export(module.exports, "isLoadingSelector", () => $0a42648be66bacce$export$c077f23183070903);
$parcel$export(module.exports, "doNotUseIsLoadingPromiseSelector", () => $0a42648be66bacce$export$2ca9575c7da6bf18);
$parcel$export(module.exports, "isPreviewSelector", () => $0a42648be66bacce$export$b33a1a8958a8d805);
$parcel$export(module.exports, "isCompletedLoadingSelector", () => $0a42648be66bacce$export$9b99fb9e23fc133);
$parcel$export(module.exports, "loadingStageSelector", () => $0a42648be66bacce$export$18bc980d36bf93d);
$parcel$export(module.exports, "isDeleteIssueModalOpenSelector", () => $0a42648be66bacce$export$7cfd3e0dd7059b87);
$parcel$export(module.exports, "isDeletingIssueSelector", () => $0a42648be66bacce$export$d414d8eddcb409e4);
$parcel$export(module.exports, "didIssueDeleteFailSelector", () => $0a42648be66bacce$export$834732624d2c73e1);
$parcel$export(module.exports, "errorSelector", () => $0a42648be66bacce$export$47aec13333381be0);
$parcel$export(module.exports, "errorMessageSelector", () => $0a42648be66bacce$export$9b1097e17c0e6dc2);
$parcel$export(module.exports, "getUserByIdSelector", () => $0a42648be66bacce$export$801a2f2bd4059665);
$parcel$export(module.exports, "parentLevelIssuesSelector", () => $0a42648be66bacce$export$aa8980c49aba4478);
$parcel$export(module.exports, "baseAriSelector", () => $0a42648be66bacce$export$fa12ae06e35ebd67);
$parcel$export(module.exports, "issueAriSelector", () => $0a42648be66bacce$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "isEpicSelector", () => $0a42648be66bacce$export$6e8ebe94ad8bb62b);
$parcel$export(module.exports, "isEpicIssueTypeSelector", () => $0a42648be66bacce$export$460d8048474fa8a2);
$parcel$export(module.exports, "getIssueSummarySelector", () => $0a42648be66bacce$export$57e1ff0824f418cd);
$parcel$export(module.exports, "isServiceDeskSelector", () => $0a42648be66bacce$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isCustomerServiceSelector", () => $0a42648be66bacce$export$abb64932cd9b1784);
$parcel$export(module.exports, "shouldUseRelayCommentsSelector", () => $0a42648be66bacce$export$8844cb90749a3c4e);

var $ahm5r = parcelRequire("ahm5r");

var $FhXEJ = parcelRequire("FhXEJ");

var $8oOr4 = parcelRequire("8oOr4");

var $4cTDP = parcelRequire("4cTDP");

var $5EgB1 = parcelRequire("5EgB1");

var $6t0ps = parcelRequire("6t0ps");
const $0a42648be66bacce$var$LOADING = 'LOADING';
const $0a42648be66bacce$var$PREVIEW = 'PREVIEW';
const $0a42648be66bacce$var$COMPLETE = 'COMPLETE';
const $0a42648be66bacce$export$ccebe5cc5854d0fa = (state)=>state.entities;
const $0a42648be66bacce$export$852a6c34ff1a2e77 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities ? entities.project : null);
const $0a42648be66bacce$export$185c0864c82372e3 = (state)=>state.ui;
const $0a42648be66bacce$export$27493ac3d8611290 = (state)=>state.agile;
const $0a42648be66bacce$export$fa3ac1f794979805 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities.issue);
const $0a42648be66bacce$export$87f5d716429f733 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities.issueLinks);
const $0a42648be66bacce$export$c4ebdc93969b82cc = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities.refreshedOn);
const $0a42648be66bacce$export$40cfdc5e96db7759 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.flags);
const $0a42648be66bacce$export$4c9d6034f65d22f4 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? project.projectId : null);
const $0a42648be66bacce$export$9edb3f63d1bd8546 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? [
        project.projectId
    ] : []);
const $0a42648be66bacce$export$404de5ac601b84bc = (0, $ahm5r.createSelector)($0a42648be66bacce$export$852a6c34ff1a2e77, (project)=>project ? project.projectKey : null);
const $0a42648be66bacce$export$69316f88206ca90b = (0, $ahm5r.createSelector)($0a42648be66bacce$export$852a6c34ff1a2e77, (project)=>project && project.projectType ? project.projectType : null);
const $0a42648be66bacce$export$d94d544d4b2e1310 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$852a6c34ff1a2e77, (project)=>!!project && project.isSimplified);
const $0a42648be66bacce$export$b5a68452fc64275d = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (0, $5EgB1.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>loggedInAccountId ? entities.users[loggedInAccountId] : null);
const $0a42648be66bacce$export$e0efa9c12379be7a = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (0, $5EgB1.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.avatarUrl : null;
});
const $0a42648be66bacce$export$4f56a07246719eb0 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (0, $5EgB1.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.displayName : null;
});
const $0a42648be66bacce$export$e10c57d263d23c49 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities.parentIssue);
const $0a42648be66bacce$export$ac6f9fd801c94fff = (0, $ahm5r.createSelector)($0a42648be66bacce$export$b5a68452fc64275d, (loggedInUser)=>loggedInUser ? loggedInUser.timeZone : undefined);
const $0a42648be66bacce$export$66c501bed2fcd648 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$fa3ac1f794979805, (issue)=>issue && issue.id);
const $0a42648be66bacce$export$45347d9f8a67561b = (0, $ahm5r.createSelector)($0a42648be66bacce$export$d94d544d4b2e1310, (isSimplified)=>!isSimplified);
const $0a42648be66bacce$export$c077f23183070903 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.loadingStage === $0a42648be66bacce$var$LOADING);
const $0a42648be66bacce$export$2ca9575c7da6bf18 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.doNotUseIsLoadingPromise);
const $0a42648be66bacce$export$b33a1a8958a8d805 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.loadingStage === $0a42648be66bacce$var$PREVIEW);
const $0a42648be66bacce$export$9b99fb9e23fc133 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.loadingStage === $0a42648be66bacce$var$COMPLETE);
const $0a42648be66bacce$export$18bc980d36bf93d = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.loadingStage);
const $0a42648be66bacce$export$7cfd3e0dd7059b87 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>!!(ui.issueDeletion && ui.issueDeletion.isDeleteIssueModalOpen));
const $0a42648be66bacce$export$d414d8eddcb409e4 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.isDeletingIssue : false);
const $0a42648be66bacce$export$834732624d2c73e1 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.didIssueDeleteFail : false);
const $0a42648be66bacce$export$47aec13333381be0 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.error);
const $0a42648be66bacce$export$9b1097e17c0e6dc2 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.errorMessage);
const $0a42648be66bacce$export$801a2f2bd4059665 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>(userId)=>userId ? entities.users[userId] : undefined);
const $0a42648be66bacce$export$aa8980c49aba4478 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities.parentLevelIssues);
const $0a42648be66bacce$export$a60a6c96db10acc4 = ()=>'jira';
const $0a42648be66bacce$export$57c6957997fb7f1d = (0, $ahm5r.createSelector)($0a42648be66bacce$export$69316f88206ca90b, (0, $FhXEJ.projectTypeToCanonicalId));
const $0a42648be66bacce$export$fa12ae06e35ebd67 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$a60a6c96db10acc4, (0, $5EgB1.cloudIdSelector), (resourceOwner, cloudId)=>cloudId ? `ari:cloud:${resourceOwner}:${cloudId}` : null);
const $0a42648be66bacce$export$a2cdbba2136e72d3 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$fa12ae06e35ebd67, $0a42648be66bacce$export$66c501bed2fcd648, (baseAri, issueId)=>{
    if (!baseAri || !issueId) return null;
    return `${baseAri}:issue/${issueId}`;
});
const $0a42648be66bacce$export$27abc48b8d528300 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$27493ac3d8611290, (agile)=>agile && agile.epic && agile.epic.key || null);
const $0a42648be66bacce$export$d062a59cf4fc9cec = (fields)=>({}).hasOwnProperty.call(fields, (0, $8oOr4.EPIC_ISSUES));
const $0a42648be66bacce$export$6e8ebe94ad8bb62b = (0, $ahm5r.createSelector)((0, $6t0ps.fieldsSelector), (fields)=>$0a42648be66bacce$export$d062a59cf4fc9cec(fields));
const $0a42648be66bacce$export$88630f3045704997 = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'hierarchy-level-same-level')) return fields['hierarchy-level-same-level'].value.name === 'Epic';
    return false;
};
const $0a42648be66bacce$export$460d8048474fa8a2 = (0, $ahm5r.createSelector)((0, $6t0ps.fieldsSelector), (fields)=>$0a42648be66bacce$export$88630f3045704997(fields));
const $0a42648be66bacce$export$697a560dc772eca6 = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'status')) return fields.status.value?.statusCategory?.id;
};
const $0a42648be66bacce$export$6395cbfb900cdf4e = (0, $ahm5r.createSelector)((0, $6t0ps.fieldsSelector), (fields)=>$0a42648be66bacce$export$697a560dc772eca6(fields));
const $0a42648be66bacce$export$57e1ff0824f418cd = (0, $ahm5r.createSelector)((0, $6t0ps.fieldsSelector), (fields)=>$0a42648be66bacce$export$7bead7bb2ab962ba(fields));
const $0a42648be66bacce$export$7bead7bb2ab962ba = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'summary')) return fields.summary.value;
};
const $0a42648be66bacce$export$43d733e4b7e8c7d0 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$69316f88206ca90b, (projectType)=>projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT));
const $0a42648be66bacce$export$abb64932cd9b1784 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$69316f88206ca90b, (projectType)=>projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT));
const $0a42648be66bacce$export$8844cb90749a3c4e = (0, $ahm5r.createSelector)($0a42648be66bacce$export$69316f88206ca90b, (projectType)=>{
    const isJiraIssue = projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.CORE_PROJECT);
    return isJiraIssue && (0, $4cTDP.fg)('relay-migration-issue-comments');
});

});

parcelRegister("GhTyR", function(module, exports) {
$parcel$export(module.exports, "permissionsSelector", () => $db89709ba3523ed2$export$7a13e26fbaa74911);
$parcel$export(module.exports, "canBeAssignedToIssuesPermissionsSelector", () => $db89709ba3523ed2$export$6da6e9cc5af6cc92);
$parcel$export(module.exports, "canAdministerProjectPermissionsSelector", () => $db89709ba3523ed2$export$106fd3c30fc8b230);
$parcel$export(module.exports, "canAdministerJiraPermissionsSelector", () => $db89709ba3523ed2$export$adf4ccad5657586d);
$parcel$export(module.exports, "canModifyReporterPermissionsSelector", () => $db89709ba3523ed2$export$85a3c8518f632ff1);
$parcel$export(module.exports, "canAssignIssuesPermissionsSelector", () => $db89709ba3523ed2$export$f58a91878385514);
$parcel$export(module.exports, "canCreateChildrenPermissionsSelector", () => $db89709ba3523ed2$export$183d12154c212e2b);
$parcel$export(module.exports, "canExportIssueSelector", () => $db89709ba3523ed2$export$a409252beda5dd99);
$parcel$export(module.exports, "watchersPermissionsSelector", () => $db89709ba3523ed2$export$b3bd1cf4683807d8);
$parcel$export(module.exports, "canViewDevToolsPermissionsSelector", () => $db89709ba3523ed2$export$dfc7b576e23ac861);
$parcel$export(module.exports, "canUseServiceDeskAgentFeaturesSelector", () => $db89709ba3523ed2$export$1b79be16305d8111);

var $ahm5r = parcelRequire("ahm5r");

var $huH03 = parcelRequire("huH03");

var $FhXEJ = parcelRequire("FhXEJ");

var $5EgB1 = parcelRequire("5EgB1");

var $6az7p = parcelRequire("6az7p");
const $db89709ba3523ed2$var$internalPermissionsSelector = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.permissions || {});
const $db89709ba3523ed2$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm = new Set([
    // In the BE this is not technically a veto'd permission, however it simplifies the FE code to pretend that it is.
    'canUseServiceDeskAgentFeatures',
    // Normal veto'd permissions as per ServiceDeskCollaboratorPermissionOverrideStrategy in BE
    'canEditIssues',
    'canTransitionIssues',
    'canScheduleIssues',
    'canMoveIssue',
    'canAssignIssues',
    'canBeAssignedToIssues',
    'canDeleteIssue',
    'canManageWatchers',
    'canEditAllComments',
    'canDeleteAllComments',
    'canDeleteAllAttachments',
    'canLogWork',
    'canEditOwnWorklogs',
    'canEditAllWorklogs',
    'canDeleteOwnWorklogs',
    'canDeleteAllWorklogs',
    // These should be vetoed, but aren't requested by JFE yet
    'canResolveIssues',
    'canViewReadonlyWorkflow',
    'canCloseIssues',
    'canModifyReporter',
    'canSetIssueSecurity',
    'canArchiveIssue',
    'canUnarchiveIssue'
]);
const $db89709ba3523ed2$export$7a13e26fbaa74911 = (0, $ahm5r.createSelector)((0, $5EgB1.appPermissionsSelector), (0, $6az7p.projectTypeSelector), $db89709ba3523ed2$var$internalPermissionsSelector, (0, $5EgB1.tenantHasActiveServiceDeskLicenseSelector), (applicationPermissions, projectType, permissions, tenantHasActiveServiceDeskLicense)=>{
    if (projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) && tenantHasActiveServiceDeskLicense) {
        const { canUseServiceDeskAgentFeatures: canUseServiceDeskAgentFeatures } = permissions;
        const hasJsdAppRole = applicationPermissions.hasServiceDeskAccess;
        return (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(permissions, (hasPermission, key)=>$db89709ba3523ed2$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm.has(key) ? hasPermission && hasJsdAppRole && canUseServiceDeskAgentFeatures : hasPermission);
    }
    return permissions;
});
const $db89709ba3523ed2$export$6da6e9cc5af6cc92 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>!!permissions.canBeAssignedToIssues);
const $db89709ba3523ed2$export$106fd3c30fc8b230 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerProject);
const $db89709ba3523ed2$export$adf4ccad5657586d = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerJira);
const $db89709ba3523ed2$var$canViewWatchersPermissionsSelector = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canViewWatchers);
const $db89709ba3523ed2$var$canManageWatchersPermissionsSelector = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canManageWatchers);
const $db89709ba3523ed2$export$85a3c8518f632ff1 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canModifyReporter);
const $db89709ba3523ed2$export$f58a91878385514 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canAssignIssues);
const $db89709ba3523ed2$export$183d12154c212e2b = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>!!permissions.canCreateChildren);
const $db89709ba3523ed2$export$a409252beda5dd99 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canExportIssue);
const $db89709ba3523ed2$export$b3bd1cf4683807d8 = (0, $ahm5r.createSelector)($db89709ba3523ed2$var$canViewWatchersPermissionsSelector, $db89709ba3523ed2$var$canManageWatchersPermissionsSelector, (canViewWatchers, canManageWatchers)=>({
        canViewWatchers: canViewWatchers,
        canManageWatchers: canManageWatchers
    }));
const $db89709ba3523ed2$export$ca6b7f39a3de4ff9 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canBrowseUsers);
const $db89709ba3523ed2$export$dfc7b576e23ac861 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canViewDevTools);
const $db89709ba3523ed2$export$1b79be16305d8111 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canUseServiceDeskAgentFeatures);

});

parcelRegister("9B5nT", function(module, exports) {
$parcel$export(module.exports, "canEditIssuesSelector", () => $375191aa45dd52ba$export$cdd6892c8add3e54);
$parcel$export(module.exports, "canLinkIssuesSelector", () => $375191aa45dd52ba$export$50487d0d29271836);

var $ahm5r = parcelRequire("ahm5r");

var $GhTyR = parcelRequire("GhTyR");
const $375191aa45dd52ba$export$a7a483ca0afc4ab3 = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canCloneIssue);
const $375191aa45dd52ba$export$c1f4ef01259b4eb = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canDeleteIssue);
const $375191aa45dd52ba$export$2f9dd165cbf0c5ea = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canMoveIssue);
const $375191aa45dd52ba$export$cdd6892c8add3e54 = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canEditIssues);
const $375191aa45dd52ba$export$f48030c6644c0c4d = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canAdministerJira || permissions.canAdministerProject);
const $375191aa45dd52ba$export$4e8dac873f71d13e = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canAssignIssues);
const $375191aa45dd52ba$export$50487d0d29271836 = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canLinkIssues);

});


parcelRegister("5SpFk", function(module, exports) {
$parcel$export(module.exports, "persistedChildrenIssuesSelector", () => $f46b95ea9d09afe0$export$e4b1249129a38a60);

var $ahm5r = parcelRequire("ahm5r");

var $6az7p = parcelRequire("6az7p");
const $f46b95ea9d09afe0$export$e4b1249129a38a60 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.childrenIssues || []);

});

parcelRegister("8mcrY", function(module, exports) {
$parcel$export(module.exports, "isSubtaskSelector", () => $d35ae6625d4cba73$export$15fea4741156936);
$parcel$export(module.exports, "subtaskEntitiesSelector", () => $d35ae6625d4cba73$export$17e529874841c746);
$parcel$export(module.exports, "hasSubtasksSelector", () => $d35ae6625d4cba73$export$f363078714850fd9);
$parcel$export(module.exports, "canCreateSubtaskSelector", () => $d35ae6625d4cba73$export$151aaebeef1cfe63);

var $ahm5r = parcelRequire("ahm5r");

var $4cTDP = parcelRequire("4cTDP");


var $8oOr4 = parcelRequire("8oOr4");

var $5EgB1 = parcelRequire("5EgB1");

var $6t0ps = parcelRequire("6t0ps");

var $6az7p = parcelRequire("6az7p");

var $GhTyR = parcelRequire("GhTyR");

var $5v1zn = parcelRequire("5v1zn");

var $aRxHj = parcelRequire("aRxHj");

var $4372d = parcelRequire("4372d");

var $6Z7vV = parcelRequire("6Z7vV");

var $dzwJE = parcelRequire("dzwJE");
const $d35ae6625d4cba73$export$15fea4741156936 = (0, $ahm5r.createSelector)((0, $4372d.issueTypeSelector), (issueType)=>!!(issueType && issueType.subtask));
const $d35ae6625d4cba73$export$17e529874841c746 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.subtasks || []);
const $d35ae6625d4cba73$export$f363078714850fd9 = (0, $ahm5r.createSelector)($d35ae6625d4cba73$export$17e529874841c746, (0, $6t0ps.childIssuesLimitUrlSelector), (subtasks, getChildIssuesLimitUrl)=>subtasks.length > 0 || Boolean(getChildIssuesLimitUrl((0, $8oOr4.SUBTASKS))));
const $d35ae6625d4cba73$export$899afcd59181acbb = (0, $ahm5r.createSelector)((0, $6az7p.isSimplifiedProjectSelector), (0, $aRxHj.isIssueBaseLevel), (0, $5v1zn.hasChildrenIssuesSelector), $d35ae6625d4cba73$export$f363078714850fd9, (isSimplifiedProject, issueBaseLevel, hasChildrenIssues, hasSubtasks)=>isSimplifiedProject ? issueBaseLevel && hasChildrenIssues : hasSubtasks);
const $d35ae6625d4cba73$export$58b46fbc7ab224f6 = (0, $ahm5r.createSelector)((0, $dzwJE.hasUnsupportedTypeSelector), (0, $6Z7vV.projectHasSubtaskValidatorsSelector), (hasRequiredFields, hasSubtaskValidators)=>hasRequiredFields || hasSubtaskValidators);
// Deprecated. Use jira-settings-hook instead if possible
const $d35ae6625d4cba73$var$isSubtaskEnabledSelector = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), ({ jiraSettings: jiraSettings })=>jiraSettings?.subtasksConfiguration?.enabled);
const $d35ae6625d4cba73$export$151aaebeef1cfe63 = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), $d35ae6625d4cba73$export$15fea4741156936, (0, $dzwJE.isSubtaskTypesPresentSelector), $d35ae6625d4cba73$export$58b46fbc7ab224f6, (0, $5EgB1.isMobileSelector), (0, $5EgB1.isBitbucketSelector), (0, $5EgB1.isServiceDeskSelector), (0, $6az7p.isSimplifiedProjectSelector), $d35ae6625d4cba73$var$isSubtaskEnabledSelector, (0, $6az7p.projectSelector), (0, $aRxHj.isIssueBaseLevel), ({ canCreateSubtask: canCreateSubtaskPermission }, isSubtask, typesPresent, shouldUseFallbackDialog, isMobile, isBitbucket, isServicedesk, isSimplified, subtasksEnabled, project, issueBaseLevel)=>{
    const canCreateSubtask = (0, $4cTDP.fg)('issue-jiv-20971-remove-subtask-quick-add') ? canCreateSubtaskPermission && issueBaseLevel : canCreateSubtaskPermission;
    const shouldHideForMobileOrBitbucket = shouldUseFallbackDialog ? isMobile || isBitbucket : false;
    const isProjectActive = (project?.projectStatus ?? (0, $788556c08796d29c$export$62113557945f790a)) === (0, $788556c08796d29c$export$62113557945f790a);
    const shouldShowSubtask = isServicedesk ? !isSimplified : true;
    return !!(canCreateSubtask && !isSubtask && typesPresent && !shouldHideForMobileOrBitbucket && shouldShowSubtask && subtasksEnabled && isProjectActive);
});

});
const $788556c08796d29c$export$62113557945f790a = 'PROJECT_ACTIVE';
const $788556c08796d29c$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $788556c08796d29c$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';

parcelRegister("5v1zn", function(module, exports) {
$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $9a3e5c2d7cd31882$export$29f34d4d7c528e9c);

var $ahm5r = parcelRequire("ahm5r");

var $8dH3d = parcelRequire("8dH3d");

var $3mZMJ = parcelRequire("3mZMJ");

var $6t0ps = parcelRequire("6t0ps");
const $9a3e5c2d7cd31882$var$childrenIssueSelector = (0, $6t0ps.fieldSelector)((0, $3mZMJ.CHILDREN_ISSUES));
const $9a3e5c2d7cd31882$export$29f34d4d7c528e9c = (0, $ahm5r.createSelector)($9a3e5c2d7cd31882$var$childrenIssueSelector, (0, $6t0ps.childIssuesLimitUrlSelector), (childrenIssues, getChildIssuesLimitUrl)=>childrenIssues ? !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(childrenIssues.value) || Boolean(getChildIssuesLimitUrl((0, $3mZMJ.CHILDREN_ISSUES))) : false);

});

parcelRegister("4372d", function(module, exports) {
$parcel$export(module.exports, "createFullIssueUrl", () => $4b8f37979127d2f5$export$f107e3172d0c8a79);
$parcel$export(module.exports, "issueTypeSelector", () => $4b8f37979127d2f5$export$c5a236f192993436);
$parcel$export(module.exports, "fullIssueUrlSelector", () => $4b8f37979127d2f5$export$14eeb219bfe6649b);
$parcel$export(module.exports, "issueTypeNameSelector", () => $4b8f37979127d2f5$export$477df8db13e4dac3);
$parcel$export(module.exports, "issueTypeHierarchyLevelSelector", () => $4b8f37979127d2f5$export$2bcfec06e5c80ef6);
$parcel$export(module.exports, "issueTypeIdSelector", () => $4b8f37979127d2f5$export$22410768c09b3a82);

var $ahm5r = parcelRequire("ahm5r");

var $8oOr4 = parcelRequire("8oOr4");

var $5EgB1 = parcelRequire("5EgB1");

var $6t0ps = parcelRequire("6t0ps");

var $6az7p = parcelRequire("6az7p");
const $4b8f37979127d2f5$var$createRelativeIssueUrl = (issueKey)=>`/browse/${issueKey}`;
const $4b8f37979127d2f5$export$f107e3172d0c8a79 = (issueKey)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.protocol}//${window.location.host}${$4b8f37979127d2f5$var$createRelativeIssueUrl(issueKey)}`;
const $4b8f37979127d2f5$var$issueTypeFieldSelector = (0, $6t0ps.fieldSelector)((0, $8oOr4.ISSUE_TYPE));
const $4b8f37979127d2f5$var$subtaskIssueFieldSelector = (0, $6t0ps.fieldSelector)((0, $8oOr4.SUBTASK_PARENT));
const $4b8f37979127d2f5$var$portfolioParentFieldSelector = (0, $6t0ps.fieldSelector)((0, $8oOr4.PARENT));
const $4b8f37979127d2f5$export$c5a236f192993436 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$var$issueTypeFieldSelector, (issueType)=>issueType && issueType.value);
const $4b8f37979127d2f5$export$7855e152de23b9ca = (0, $ahm5r.createSelector)((0, $5EgB1.issueKeySelector), $4b8f37979127d2f5$var$createRelativeIssueUrl);
const $4b8f37979127d2f5$export$14eeb219bfe6649b = (0, $ahm5r.createSelector)((0, $5EgB1.issueKeySelector), $4b8f37979127d2f5$export$f107e3172d0c8a79);
const $4b8f37979127d2f5$export$477df8db13e4dac3 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$export$c5a236f192993436, (issueType)=>issueType && issueType.name);
const $4b8f37979127d2f5$export$2bcfec06e5c80ef6 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$export$c5a236f192993436, (issueType)=>{
    if (!issueType) return null;
    return issueType && issueType.hierarchyLevel;
});
const $4b8f37979127d2f5$export$22410768c09b3a82 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$export$c5a236f192993436, (issueType)=>issueType && issueType.id);
const $4b8f37979127d2f5$export$4cf7e4622f7b8aee = (0, $ahm5r.createSelector)($4b8f37979127d2f5$export$c5a236f192993436, (issueType)=>issueType && issueType.iconUrl);
const $4b8f37979127d2f5$var$transformParentIssue = (issue)=>issue ? {
        summary: issue.summary,
        key: issue.key,
        url: $4b8f37979127d2f5$var$createRelativeIssueUrl(issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
const $4b8f37979127d2f5$var$transformSubtaskParentIssue = (issue)=>issue ? {
        summary: issue.fields.summary,
        key: issue.key,
        url: $4b8f37979127d2f5$var$createRelativeIssueUrl(issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4b8f37979127d2f5$var$transformPortfolioParentIssue = (value)=>value && value.data ? {
        summary: value.data.summary,
        key: value.data.key,
        url: $4b8f37979127d2f5$var$createRelativeIssueUrl(value.data.key),
        issueTypeName: value.data.issueTypeName || '',
        issueTypeIconUrl: value.data.issueTypeIconUrl || ''
    } : null;
const $4b8f37979127d2f5$export$77f9f02e63a0906f = (0, $ahm5r.createSelector)($4b8f37979127d2f5$var$portfolioParentFieldSelector, (portfolioParentIssue)=>$4b8f37979127d2f5$var$transformPortfolioParentIssue(portfolioParentIssue && portfolioParentIssue.value));
const $4b8f37979127d2f5$var$subtaskIssueParentSelector = (0, $ahm5r.createSelector)($4b8f37979127d2f5$var$subtaskIssueFieldSelector, (subtaskIssue)=>$4b8f37979127d2f5$var$transformSubtaskParentIssue(subtaskIssue && subtaskIssue.value));
const $4b8f37979127d2f5$var$parentIssueSelector = (0, $ahm5r.createSelector)((0, $6az7p.parentIssueEntitySelector), (parentIssue)=>$4b8f37979127d2f5$var$transformParentIssue(parentIssue));
const $4b8f37979127d2f5$export$dfeb83ef40558422 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$var$parentIssueSelector, $4b8f37979127d2f5$var$subtaskIssueParentSelector, $4b8f37979127d2f5$export$77f9f02e63a0906f, (parentIssue, subtaskIssue, portfolioParentIssue)=>parentIssue || subtaskIssue || portfolioParentIssue);
const $4b8f37979127d2f5$export$1e6d1c8ba22c2162 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$var$parentIssueSelector, (parentIssue)=>[
        parentIssue
    ].filter(Boolean));

});

parcelRegister("6Z7vV", function(module, exports) {
$parcel$export(module.exports, "projectHasSubtaskValidatorsSelector", () => $835beb127742780b$export$ecfed315b19a7565);

var $ahm5r = parcelRequire("ahm5r");
const $835beb127742780b$export$26d55645375ca9a = 'LOADING';
const $835beb127742780b$export$d71930f7f5807a72 = 'FAILED';
const $835beb127742780b$export$4c02edeb1b5e410a = 'LOADED';
const $835beb127742780b$var$hasSubtaskValidators = (hasValidators)=>hasValidators.status === $835beb127742780b$export$4c02edeb1b5e410a && hasValidators.value;
const $835beb127742780b$var$unknown = (hasValidators)=>hasValidators.status === $835beb127742780b$export$26d55645375ca9a || hasValidators.status === $835beb127742780b$export$d71930f7f5807a72;
const $835beb127742780b$export$ecfed315b19a7565 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.validators, (validators)=>{
    const val = validators.projectHasSubtaskValidators;
    return $835beb127742780b$var$hasSubtaskValidators(val) || $835beb127742780b$var$unknown(val);
});

});

parcelRegister("dzwJE", function(module, exports) {
$parcel$export(module.exports, "subtaskTypesSelector", () => $bbdf012e2b41060c$export$86a4f97fc27a0c44);
$parcel$export(module.exports, "isSubtaskTypesPresentSelector", () => $bbdf012e2b41060c$export$9a147dcac364dd81);
$parcel$export(module.exports, "hasUnsupportedTypeSelector", () => $bbdf012e2b41060c$export$3fbfbdcf57f34c2);

var $ahm5r = parcelRequire("ahm5r");

var $l7OhZ = parcelRequire("l7OhZ");
const $bbdf012e2b41060c$export$86a4f97fc27a0c44 = (0, $ahm5r.createSelector)((0, $l7OhZ.issueTypesSelector), (issueTypes)=>issueTypes.filter((type)=>type.subtask));
const $bbdf012e2b41060c$export$9a147dcac364dd81 = (0, $ahm5r.createSelector)($bbdf012e2b41060c$export$86a4f97fc27a0c44, (subtaskTypes)=>subtaskTypes.length >= 1);
const $bbdf012e2b41060c$export$3fbfbdcf57f34c2 = (0, $ahm5r.createSelector)($bbdf012e2b41060c$export$86a4f97fc27a0c44, (subtaskTypes)=>!!subtaskTypes.find((0, $l7OhZ.hasUnsupportedType)));

});
parcelRegister("l7OhZ", function(module, exports) {
$parcel$export(module.exports, "issueTypesSelector", () => $4ce8df68e83137cf$export$f5378064bf877b95);
$parcel$export(module.exports, "hasUnsupportedType", () => $4ce8df68e83137cf$export$1f59505fa2d77635);
$parcel$export(module.exports, "issueTypesForClassicProjectEpicSelector", () => $4ce8df68e83137cf$export$a0efcb09d3e23dc1);
$parcel$export(module.exports, "fetchIssueTypesStatusSelector", () => $4ce8df68e83137cf$export$bfbb65ccb13a16eb);

var $ahm5r = parcelRequire("ahm5r");

var $8dH3d = parcelRequire("8dH3d");

var $6az7p = parcelRequire("6az7p");

var $4372d = parcelRequire("4372d");
const $4ce8df68e83137cf$export$f5378064bf877b95 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.issueTypes);
// A collection of issue fields which are marked as `required`
// for the creation of an issue, but are considered as 'provided' since
// the data for these fields is supplied by JIRA.
const $4ce8df68e83137cf$var$providedRequiredFields = [
    'summary',
    'issuetype',
    'parent',
    'project'
];
const $4ce8df68e83137cf$var$isRequiredFieldProvided = (fieldName)=>$4ce8df68e83137cf$var$providedRequiredFields.find((providedFieldName)=>fieldName === providedFieldName);
// A field is considered 'unsupported' if not provided by JIRA,
// has no default value, and is a `required` field.
const $4ce8df68e83137cf$var$hasUnsupportedRequiredField = (fields)=>// @ts-expect-error - TS2769 - No overload matches this call.
    !!Object.keys(fields).find((fieldName)=>!$4ce8df68e83137cf$var$isRequiredFieldProvided(fieldName) && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        !fields[fieldName].hasDefaultValue && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        fields[fieldName].required);
const $4ce8df68e83137cf$export$1f59505fa2d77635 = (issueType)=>(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(issueType.fields) || $4ce8df68e83137cf$var$hasUnsupportedRequiredField(issueType.fields);
const $4ce8df68e83137cf$export$a0efcb09d3e23dc1 = (0, $ahm5r.createSelector)($4ce8df68e83137cf$export$f5378064bf877b95, (0, $4372d.issueTypeSelector), (0, $6az7p.isEpicSelector), (issueTypes, currentIssueType, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isCurrentIssueAnEpic)=>{
    const epicIssueTypeId = isCurrentIssueAnEpic && currentIssueType && currentIssueType.id;
    return issueTypes.filter(// @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'number' and 'string | boolean | undefined' have no overlap.
    (issueType)=>!issueType.subtask && issueType.id !== epicIssueTypeId);
});
const $4ce8df68e83137cf$export$bfbb65ccb13a16eb = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.fetchIssueTypesStatus);

});







//# sourceMappingURL=async-activity-feed-item-history.8488b062.js.map
